import CommonState from './CommonState'
import * as SystemConstants from './SystemConstants'
import * as SeaExportConstants from './SeaExportConstants'
import i18n from '@/lang'
import * as BookingTerm from '@/class/cargo/model/parameters/BookingTerm'
import * as PartnerServiceItem from '@/class/cargo/model/parameters/PartnerServiceItem'
import { YES_NO_TYPES } from '@/class/cargo/model/parameters/RadioStatusConstants'
/**
 * 验证规则的相关常量
 *
 * @author Marco
 */

// ----------------
// 验证节点
// ----------------

export const NODE_PRE_COMMIT = new CommonState(1, '预提交', 'Pre Commit')
export const NODE_COMMIT = new CommonState(2, '提交', 'Commit')
export const NODE_PRINT_PROFIT = new CommonState(3, '打印利润分析表', 'Print Profit')
//    export const NODE_FINANCIAL_AUDIT= new CommonState(4, "财务审核", "Finalcial Audit");
export const NODE_REMOTE_BOOKING = new CommonState(5, '提交远程订舱', 'Remote Booking')
export const NODE_HBLZB_PRINT = new CommonState(6, 'HBL正本打印', 'HBLZB Print')
export const NODE_BOOKING_EDI_UPLOAD = new CommonState(7, '订舱EDI上传', 'BookingEdi Upload')
export const NODE_SINGLE_RELEASE = new CommonState(8, '放单', 'Single Release')
export const NODE_MANAGER_COMMIT = new CommonState(9, '主管提交', 'Manager Commit')
export const NODE_AUDIT_COMMIT = new CommonState(10, '亏单审核', 'Loss Doc Approval')
export const NODE_SAVE = new CommonState(11, '保存', 'Save')
export const NODE_HBLDF_PRINT = new CommonState(12, 'HBL电放打印', 'HBLDF Print')
export const NODE_FINANCIAL_AUDIT = new CommonState(13, '财务审核', 'Financial audit')
export const NODE_SAVE_BUSINESS = new CommonState(14, '业务保存', 'Business Preservation')
export const NODE_SAVE_USER = new CommonState(16, '保存用户', 'Save User')
export const NODE_BOOKING_VERIFY = new CommonState(15, '订舱审核/转正式业务', 'Booking Verify')
export const NODE_SEND_DESTINATION_AGENT_EMAIL = new CommonState(17, '发送目的港代理邮件', 'Send destination port agent email')
export const NODE_SAVE_REMOTE_BOOKING = new CommonState(18, '远程订舱保存', 'Save Remote Booking')
export const NODE_NEW_FINANCE_ADJUSTMENT = new CommonState(19, '新增财务调整', 'New Finance Adjustment')
export const NODE_SAVE_PARTNER = new CommonState(20, '保存合作伙伴', 'Save Partner')
export const NO_FEE_REFUND = new CommonState(21, '无费用退关', 'No fee refund')
export const NODE_CRM_CUSTOMER_INPUT_SAVE = new CommonState(22, 'CRM客户录入保存', 'CRM Customer Input Save')
export const NODE_SAVE_CUSTOMS = new CommonState(23, '保存报关委托', 'Save customs declaration commission')
export const NODE_AR_SURE = new CommonState(24, '应收账单确认', 'Account receivable confirmation')
export const NODE_AP_SURE = new CommonState(25, '应付账单确认', 'Account payable confirmation')
export const NODE_AR_RECHECK = new CommonState(26, '应收账单复核', 'Bill receivable review')
export const NODE_AP_RECHECK = new CommonState(27, '应付账单复核', 'Bill payable review')
export const NODE_IMPORT_CHARGE_WRITE_OFF = new CommonState(28, '导入销账', 'Import for write-off')
export const NODE_LADING_BILL_EDI_UPLOAD = new CommonState(30, '提单EDI上传', 'Lading bill edi Upload')
export const NODE_BILL_PAYMENT_SAVE = new CommonState(29, '付款申请单保存', 'Bill payment save')
export const NODE_OCR_CREATE_JOB = new CommonState(32, 'OCR识别托书生成业务', 'Ocr create Job')
export const OPERATION_INSTRUCTION_VALID = new CommonState(31, '操作指令验证', 'Operation instruction valid')
// CARGO-47750 应收账单确认，增加必录项校验“纳税人识别号”、“客户邮箱”
export const NODE_BILL_AR_SURE = new CommonState(33, '应收账单确认(账单)', 'Internal account receivable confirmation')
// CARGO-46883 验证规则配置，必填项：需要加验证节点【委托】验证项目【自定义岗位1】
export const NODE_CROSS_DELEGATION = new CommonState(34, '交叉委托', 'Cross delegation')
export const NODE_RELEASE_ORDER_REVIEW_DELEGATION = new CommonState(35, '放单审核', 'Release Order Review')
export const NODE_INVOICE_CONFIRM_OR_RECEPT = new CommonState(36, '发票确定收/开票', 'Invoice confirmation receipt/invoicing')
export const NODE_SAVE_BILLING = new CommonState(37, '账单保存', 'Save Billing')
export const NODE_SAVE_INVOICE = new CommonState(38, '发票保存', 'Save Invoice')
export const NODE_COMMIT_PARTNER = new CommonState(39, '提交合作伙伴', 'Commit Partner')

export const CHECK_NODES = new Set([
  NODE_PRE_COMMIT,
  NODE_COMMIT,
  NODE_MANAGER_COMMIT,
  NODE_PRINT_PROFIT,
  //      NODE_FINANCIAL_AUDIT,
  NODE_REMOTE_BOOKING,
  NODE_HBLZB_PRINT,
  NODE_AUDIT_COMMIT,
  NODE_BOOKING_EDI_UPLOAD,
  NODE_SINGLE_RELEASE,
  NODE_HBLDF_PRINT,
  NODE_FINANCIAL_AUDIT,
  NODE_SAVE_BUSINESS,
  NODE_OCR_CREATE_JOB,
  NODE_SAVE_USER,
  NODE_BOOKING_VERIFY,
  NODE_SEND_DESTINATION_AGENT_EMAIL,
  NODE_SAVE_REMOTE_BOOKING,
  NODE_NEW_FINANCE_ADJUSTMENT,
  NODE_SAVE_PARTNER,
  NO_FEE_REFUND,
  NODE_CRM_CUSTOMER_INPUT_SAVE,
  NODE_SAVE_CUSTOMS,
  NODE_AR_SURE,
  NODE_AP_SURE,
  NODE_AR_RECHECK,
  NODE_AP_RECHECK,
  NODE_BILL_AR_SURE,
  NODE_IMPORT_CHARGE_WRITE_OFF,
  NODE_LADING_BILL_EDI_UPLOAD,
  NODE_BILL_PAYMENT_SAVE,
  OPERATION_INSTRUCTION_VALID,
  NODE_CROSS_DELEGATION,
  NODE_RELEASE_ORDER_REVIEW_DELEGATION,
  NODE_INVOICE_CONFIRM_OR_RECEPT,
  NODE_SAVE_BILLING,
  NODE_SAVE_INVOICE,
  NODE_COMMIT_PARTNER
])

// ----------------
// 必录项
// ----------------

export const REQUIRE_OP = new CommonState('OP', '操作', 'Op')
export const REQUIRE_CSR = new CommonState('CSR', '客服', 'Csr')
export const REQUIRE_OPDEPARTMENT = new CommonState('OPDEPARTMENT', '操作部门', 'OpDepartment')
export const REQUIRE_SALES = new CommonState('SALES', '销售', 'Sales')
export const REQUIRE_DOC = new CommonState('DOC', '单证', 'Doc')
export const REQUIRE_DCDEPARTMENT = new CommonState('DCDEPARTMENT', '单证部门', 'DcDepartment')
export const REQUIRE_DCOFFICE = new CommonState('DCOFFICE', '单证公司', 'DcOffice')
export const REQUIRE_CSRDEPARTMENT = new CommonState('CSRDEPARTMENT', '客服部门', 'CsrDepartment')
export const REQUIRE_CSROFFICE = new CommonState('CSROFFICE', '客服公司', 'CsrOffice')
export const REQUIRE_PLANNER = new CommonState('PLANNER', '航线负责人', 'planner')
// CARGO-6906 提交验证项，增加【揽货销售】字段
export const REQUIRE_SALES_OF_GOODS = new CommonState('SALES_OF_GOODS', '揽货销售', 'salesOfGoods')
// 现场操作
export const REQUIRE_SITE_OP = new CommonState('SITE_OP', '现场操作', 'Site op')
export const REQUIRE_ETD = new CommonState('ETD', '开航日期(ETD)', 'ETD')
export const REQUIRE_ETA = new CommonState('ETA', '到港日期(ETA)', 'ETA')
// CARGO-6602 铁路操作中增加：实际发运日期
export const REQUIRE_ATD = new CommonState('ATD', '实际开航日期(ATD)', 'ATD')
export const REQUIRE_ATA = new CommonState('ATA', '实际到港日期(ATA)', 'ATA')
export const REQUIRE_BARGECUSTOMCUTOFF = new CommonState('BARGECUSTOMCUTOFF', '截关时间', 'bargeCustomCutoff')
export const REQUIRE_DELIVER_DATE = new CommonState('DELIVER_DATE', '提货日期', 'Deliver Date')
export const REQUIRE_TRANS_DATE = new CommonState('TRANS_DATE', '换单日期', 'Trans Date')
export const REQUIRE_ESTIMATE_WAREHOUSE_DATE = new CommonState('ESTIMATE_WAREHOUSE_DATE', '预计进仓日期', 'Estimate Warehouse Date')
// CARGO-5179  提交，预提交，主管提交在验证项目必录项中加上 目的港代理/截关日期/截港日期/截单日期/贸易条款字段
export const DESTINATION_AGENT = new CommonState('DESTINATION_AGENT', '目的港代理', 'destinationAgent')
export const TERMINAL_CUTOFF = new CommonState('TERMINAL_CUTOFF', '截港日期', 'terminalCutoff')
export const FILECUTOFF = new CommonState('FILECUTOFF', '截单日期', 'fileCutoff')
// 送货完成日期
export const REQUIRE_DELIVERY_COMPLETION_DATE = new CommonState('DELIVERY_COMPLETION_DATE', '送货完成日期', 'Delivery completion date')
export const REQUIRE_BL_NO = new CommonState('BL_NO', '提单号', 'B/L NO')
export const REQUIRE_VESSEL = new CommonState('VESSEL', '船名/班车', 'Vessel')
export const REQUIRE_VOYAGE_NO = new CommonState('VOYAGE_NO', '航次', 'Voyage No')
export const REQUIRE_FLIGHT_NO = new CommonState('FLIGHT_NO', '航班号', 'Flight No')
// 车次
export const REQUIRE_VOYAGE_FLIGHT = new CommonState('VOYAGE_FLIGHT', '车次', 'Voyage flight')
export const REQUIRE_BOOKING_AGENT = new CommonState('BOOKING_AGENT', '订舱代理', 'Booking Agent')
export const REQUIRE_CARRIER = new CommonState('CARRIER', '船/航空公司', 'Carrier')
export const REQUIRE_WAREHOUSE = new CommonState('WAREHOUSE', '仓库', 'Warehouse')
export const REQUIRE_CARRIERAGENT = new CommonState('CARRIERAGENT', '船代', 'carrierAgent')
// 报关行
export const REQUIRE_CUSTOMS_BROKER = new CommonState('CUSTOMS_BROKER', '报关行', 'Customs Broker')
// 运输公司
export const REQUIRE_CARRYING_CMP = new CommonState('CARRYING_CMP', '运输公司', 'Haulage Company')
// 发运代理
export const REQUIRE_FORWARDING_AGENT = new CommonState('FORWARDING_AGENT', '发运代理', 'forwarding agent')
export const REQUIRE_LOADINGPORTCODE = new CommonState('LOADINGPORTCODE', '起运港', 'loadingPortCode')
export const REQUIRE_DISCHARGINGPORTCODE = new CommonState('DISCHARGINGPORTCODE', '目的港', 'dischargingPortCode')
// 交货地（空运叫交货地，海运叫最终目的地）
export const REQUIRE_DESTINATION_PLACE = new CommonState('DESTINATION_PLACE', '交货地', 'Destination Place')
// 贸易方式
export const REQUIRE_TRADE_TERM = new CommonState('TRADE_TERM', '贸易方式', 'trade term')
export const REQUIRE_INCOTERM = new CommonState('INCOTERM', '贸易条款/成交条款', 'incoterm')
export const REQUIRE_CARGOSOURCE = new CommonState('CARGOSOURCE', '揽货类型', 'CargoSource')
export const REQUIRE_LOADINGTERM = new CommonState('LOADINGTERM', '本地服务', 'loadingTerm')
// 整拼类型
export const REQUIRE_CONTAINER_LOAD_TYPE = new CommonState('CONTAINER_LOAD_TYPE', '整拼类型', 'Container Load Type')
// 进仓编号
export const REQUIRE_WAREHOUSE_NO = new CommonState('WAREHOUSE_NO', '进仓编号', 'warehouse no')
export const REQUIRE_PONO = new CommonState('PONO', '项目编号', 'PONO')
export const REQUIRE_SONO = new CommonState('SONO', 'SO NO', 'SO NO')
// CARGO-6216，基本配置-验证规则配置模块，必录项类型，新增【业务参考号】验证项目
export const REQUIRE_CUSTOMER_REF_NO = new CommonState('CUSTOMER_REF_NO', '业务参考号', 'CustomerRefNo')
export const REQUIRE_CUSTOMJOBTYPE = new CommonState('CUSTOMJOBTYPE', '自定义业务类型', 'customJobType')
// 唛头
export const REQUIRE_MARK = new CommonState('MARK', '唛头', 'Mark')
export const REQUIRE_CARGOCHINESENAME = new CommonState('CARGOCHINESENAME', '中文品名', 'cargoChineseName')
export const REQUIRE_CARGOENGLISHNAME = new CommonState('CARGOENGLISHNAME', '英文品名', 'cargoEnglishName')
// cargo-1296 基本配置-验证规则配置模块，必录项类型，新增：自定义字段1，2，3 、货物类型、到库日期、发货人、收货人
export const REQUIRE_USER_DEFINED_FIELD_1 = new CommonState('USER_DEFINED_FIELD_1', '自定义字段1', 'userDefinedField1')
export const REQUIRE_USER_DEFINED_FIELD_2 = new CommonState('USER_DEFINED_FIELD_2', '自定义字段2', 'userDefinedField2')
export const REQUIRE_USER_DEFINED_FIELD_3 = new CommonState('USER_DEFINED_FIELD_3', '自定义字段3', 'userDefinedField3')
export const REQUIRE_CARGO_TYPE = new CommonState('CARGO_TYPE', '货物类型', 'cargoType')
export const REQUIRE_ARRIVE_STORAGE_DATE = new CommonState('ARRIVE_STORAGE_DATE', '到库日期', 'arriveStorageDate')
// 操作要求
export const REQUIRE_OPERATION_CONTENT = new CommonState('OPERATION_CONTENT', '操作要求', 'operation content')
// 备注
export const REQUIRE_REMARKS = new CommonState('REMARKS', '备注', 'Remarks')
// 主单运费条款
export const REQUIRE_PAYMENT_TERM_MBL = new CommonState('PAYMENT_TERM_MBL', '主单运费条款', 'PaymentTerm MBL')
export const REQUIRE_FREIGHTTERM_HBL = new CommonState('FREIGHTTERM_HBL', '分单运输条款', 'FreightTermHBL')
export const REQUIRE_SIGNPLACE_HBL = new CommonState('SIGNPLACE_HBL', '分单签单地点', 'SignPlaceBL')
export const REQUIRE_PAYMENTTERM_HBL = new CommonState('PAYMENTTERM_HBL', '分单运费条款', 'PaymentTermHBL')
export const REQUIRE_PAYMENTPLACE_HBL = new CommonState('PAYMENTPLACE_HBL', '分单付款地点', 'PaymentPlaceBL')
// CARGO-8039，基本配置-验证规则配置模块，必录项类型，新增“HS编号”、“免柜租期”、“箱号”、“封号”验证项目
export const REQUIRE_HSCODE = new CommonState('HSCODE', 'HS编码', 'hsCode')
export const REQUIRE_FREETIME = new CommonState('FREETIME', '免柜租期', 'freeTime')
export const REQUIRE_CONTAINERNO = new CommonState('CONTAINER_NO', '箱号', 'containerNo')
export const REQUIRE_SEALNO = new CommonState('SEAL_NO', '封号', 'sealNo')
export const REQUIRE_VESSELLINECODE = new CommonState('VESSELLINECODE', '航线代码', 'vesselLineCode')
// 约价性质为自有约价时，校验船公司约号
export const REQUIRE_SCNO = new CommonState('SCNO', '船公司约号', 'scNo')
// IMO
export const REQUIRE_VESSEL_IMO = new CommonState('VESSEL_IMO', 'IMO', 'IMO')
// N/A
export const REQUIRE_NA = new CommonState('NA', 'N/A', 'N/A')
// N/A CODE
export const REQUIRE_NA_CODE = new CommonState('NA_CODE', 'N/A CODE', 'N/A CODE')
// LINE CODE
export const REQUIRE_LANE_CODE = new CommonState('LANE_CODE', 'LINE CODE', 'LINE CODE')
// CODE
export const REQUIRE_SUB_CONTRACT_NO = new CommonState('SUB_CONTRACT_NO', 'CODE', 'CODE')
export const REQUIRE_SHIPPER_LINE1 = new CommonState('SHIPPER_LINE1', '发货人', 'shipperLine1')
export const REQUIRE_CONSIGNEE_LINE1 = new CommonState('CONSIGNEE_LINE1', '收货人', 'consigneeLine1')
// 通知人
export const REQUIRE_NOTIFY_LINE1 = new CommonState('NOTIFY_LINE1', '通知人', 'notifyLine1')
export const REQUIRE_BL_SCNADDR = new CommonState('BLSCNADDR', '提单收发通', 'BLSCNAddr')
export const REQUIRE_BL_CARGOENGLISHNAME = new CommonState('BLCARGOENGLISHNAME', '提单品名', 'blCargoEnglishName')
export const REQUIRE_BL_QWC = new CommonState('BLQWC', '提单件毛体', 'blQwc')
export const REQUIRE_BL_PACKING = new CommonState('BLPACKING', '提单包装', 'blPacking')
export const REQUIRE_BL_LOADINGPORT = new CommonState('BLLOADINGPORT', '提单起运港', 'blLoadingPort')
export const REQUIRE_BL_DISCHARGINGPORT = new CommonState('BLDISCHARGINGPORT', '提单卸货港', 'blDischargingPort')
export const REQUIRE_BL_DESTINATIONPORT = new CommonState('BLDESTINATIONPORT', '提单交货地', 'blDestinationPort')
export const REQUIRE_BL_DISPATCHINGPLACE = new CommonState('BLDISPATCHINGPLACE', '提单发货地', 'blDispatchingPlace')
export const REQUIRE_BL_REMARKS = new CommonState('BLREMARKS', 'HBL唛头', 'blRemarks')
export const REQUIRE_SIGNDATE_HBL = new CommonState('SIGNDATE_HBL', '分单签单日期', 'SignDateHBL')
// 箱种
export const REQUIRE_BOX_TYPE = new CommonState('EQ_TYPE', '箱种', 'Box Type')
export const REQUIRE_SEA_EQ = new CommonState('SEA_EQ', '箱型箱量', 'seaEq')
export const REQUIRE_QWC_ACTUAL = new CommonState('QWCACTUAL', '实际件毛体', 'QwcActual')
export const REQUIRE_QUANTITYCONTRACT = new CommonState('QUANTITYCONTRACT', '委托件数', 'quantityContract')
export const REQUIRE_WEIGHTCONTRACT = new CommonState('WEIGHTCONTRACT', '委托毛重', 'weightContract')
export const REQUIRE_CUBAGECONTRACT = new CommonState('CUBAGECONTRACT', '委托体积', 'cubageContract')
// 实际件数
export const REQUIRE_QUANTITY_ACTUAL = new CommonState('QUANTITY_ACTUAL', '实际件数', 'Quantity Actual')
// 实际毛重
export const REQUIRE_WEIGHT_ACTUAL = new CommonState('WEIGHT_ACTUAL', '实际毛重', 'Weight Actual')
// 实际体积
export const REQUIRE_CUBAGE_ACTUAL = new CommonState('CUBAGE_ACTUAL', '实际体积', 'Cubage Actual')
// 订舱件数
export const REQUIRE_QUANTITY_BOOKING = new CommonState('QUANTITY_BOOKING', '订舱件数', 'Quantity Booking')
// 订舱毛重
export const REQUIRE_WEIGHT_BOOKING = new CommonState('WEIGHT_BOOKING', '订舱毛重', 'Weight Booking')
// 订舱体积
export const REQUIRE_CUBAGE_BOOKING = new CommonState('CUBAGE_BOOKING', '订舱体积', 'Cubage Booking')
// 换单代理（进口的换单代理实际上用的是订舱代理字段）
export const REQUIRE_EXCHANGE_AGENT = new CommonState('EXCHANGE_AGENT', '换单代理', 'Exchange Agent')
// 计费重量
export const REQUIRE_CHARGE_WEIGHT = new CommonState('CHARGE_WEIGHT', '计费重量', 'charge weight')
// CARGO-4652，广州冠业:验证规则表达式项目增加
export const REQUIRE_PACKING = new CommonState('PACKING', '包装', 'packing')
export const REQUIRE_SELLING_PRICE = new CommonState('SELLING_PRICE', '卖价', 'Selling Price')
export const REQUIRE_PB_PROPORTION = new CommonState('PB_PROPORTION', '客户分泡', 'pbProportion')
export const REQUIRE_PB_PROPORTION2 = new CommonState('PB_PROPORTION2', '供应商分泡', 'pbProportion2')
export const REQUIRE_PROFIT_RATE = new CommonState('PROFITRATE', '单票最大利润率', 'profitRate')
// CARGO-2259，新增必录项验证规则：对方账单号
export const REQUIRE_AGENT_BILLING_NO = new CommonState('AGENT_BILLING_NO', '特殊费用-代理账单号', 'agentBillingNo')
export const REQUIRE_CHARGE_RELATED_MBL = new CommonState('CHARGE_RELATED_MBL', '费用关联提单号', 'charge related mbl')

export const REQUIRE_DOOR_TO_DOOR = new CommonState('DOOR_TO_DOOR', '门点送货', 'Door-to-door delivery')
export const REQUIRE_GOODS_CATEGORIES = new CommonState('GOODS_CATEGORIES', '货物大类', 'Large categories of goods')
export const REQUIRE_OPERATION_DATE = new CommonState('OPERATION_DATE', '操作日期', 'OP Date')
export const REQUIRE_ARRIVAL_DATE = new CommonState('ARRIVAL_DATE', '运抵目的地日期', 'Arrival date at destination')
export const CHARGEABLE_WEIGHT_RT = new CommonState('CHARGE_WEIGHT', '计费重量RT', 'Chargeable weight RT')
export const MBL_CANNOT_REPEATED = new CommonState('MBL_CANNOT_REPEATED', '主单号不可重复', 'MBL No. cannot be duplicated.')
export const REQUIRE_COMPREHENSIVE_TRANSPORTATION_TYPE = new CommonState('COMPREHENSIVE_TRANSPORTATION_TYPE', '综合运输类型', 'Comprehensive transportation type')
export const REQUIRE_DESTINATION_COUNTRY = new CommonState('DESTINATION_COUNTRY', '目的国(铁路)', 'Destination country')
export const REQUIRE_OVERSEA_CSR = new CommonState('OVERSEA_CSR', '海外客服', 'Oversea Csr')
export const REQUIRE_CUSTOMER_LEVEL = new CommonState('CUSTOMER_LEVEL', '客户级别', 'Customer Level')
export const REQUIRE_CUSTOMER_SOURCE = new CommonState('CUSTOMER_SOURCE', '客户来源', 'customer source')
export const REQUIRE_CREDIT_PAYMENT_PERIOD = new CommonState('CREDIT_PAYMENT_PERIOD', '信用账款-账期', 'Credit account - Payment period')
export const REQUIRE_CREDIT_ADDITIONAL_DESCRIPTION = new CommonState('CREDIT_ADDITIONAL_DESCRIPTION', '信用账款-附加描述', 'Credit accounts receivable - Additional description')
export const REQUIRE_CONTACT_PERSON = new CommonState('CONTACT_PERSON', '联系人', 'Contact person')
export const REQUIRE_INVOICE_PAYEE = new CommonState('INVOICE_PAYEE', '开票抬头', 'Invoice payee')
export const REQUIRE_INVOICE_PAYEE_BANK = new CommonState('INVOICE_PAYEE_BANK', '开票抬头银行', 'Invoice payee bank')
export const REQUIRE_STATISTIC_AREA = new CommonState('STATISTIC_AREA', '业务统计区域', 'Service statistical area')
export const REQUIRE_BOX_ONE_WAY = new CommonState('BOX_ONE_WAY', '用箱(单程/循环)', 'Container (one way/cycle)')
export const REQUIRE_TRANSPORT_SOURCE = new CommonState('TRANSPORT_SOURCE', '运力来源', 'Transport Source')
export const REQUIRE_CUSTOMER_EXPAND_MODE = new CommonState('CUSTOMER_EXPAND_MODE', '拓客方式', 'Customer Expand Mode')
export const NUMBER_PACKING_INFORMATION_PIECES = new CommonState('NUMBER_PACKING_INFORMATION_PIECES', '装箱信息件数', 'Number Packing Information Pieces')
export const PACKING_INFORMATION_GROSS_WEIGHT = new CommonState('PACKING_INFORMATION_GROSS_WEIGHT', '装箱信息毛重', 'Packing information Gross weight')
export const PACKING_INFORMATION_VOLUME = new CommonState('PACKING_INFORMATION_VOLUME', '装箱信息体积', 'Packing information volume')
export const DOOR_NAME = new CommonState('DOOR_NAME', '门点名称', 'Door name')
// CARGO-45785 远程订舱 新增保存必填校验
export const REQUIRE_MBL = new CommonState('MBL', '未勾选MBL', ' MBL Not Checked')
export const REQUIRE_USER_DEFINED_ROLE_ID1 = new CommonState('USER_DEFINED_ROLE_ID1', '自定义岗位1', 'Custom post 1')
export const REQUIRE_USER_DEFINED_ROLE_ID2 = new CommonState('USER_DEFINED_ROLE_ID2', '自定义岗位2', 'Custom post 2')
export const BILL_TAX_ACCOUNT = new CommonState('BILL_TAX_ACCOUNT', '账单-纳税人识别号', 'Custom post 2')
export const BILL_COMPANY_EMAIL = new CommonState('BILL_COMPANY_EMAIL', '合作伙伴-开票要求-客户邮箱', 'Custom post 2')
export const REQUIRE_INVOICE_TITLE = new CommonState('INVOICE_TITLE', '开票抬头', 'Invoice Title')
export const REQUIRE_OPENING_BANK = new CommonState('OPENING_BANK', '开户银行', 'Opening bank')
export const REQUIRE_BANK_ACCOUNT_NUMBER = new CommonState('BANK_ACCOUNT_NUMBER', '银行账号', 'Bank account number')
export const REQUIRE_OUR_TITLE = new CommonState('OUR_TITLE', '我方抬头', 'Our title')
export const INVOICE_NOT_EMPTY = new CommonState('INVOICE_NOT_EMPTY', '开票信息列表', 'The invoice information list')
export const CONTACT_PHONE = new CommonState('CONTACT_PHONE', '联系人电话', 'Contact phone')
export const INFORMATION_INVOICE_TITLE = new CommonState('INFORMATION_INVOICE_TITLE', '开票信息-开票抬头', 'Invoice Information - Invoice Title')
export const INVOICE_IDENTIFICATION_NUMBER = new CommonState('INVOICE_IDENTIFICATION_NUMBER', '开票信息-纳税人识别号', 'Invoice Information - Taxpayer Identification Number')
export const INVOICE_HEADER_BANK_NOT_EMPTY = new CommonState('INVOICE_HEADER_BANK_NOT_EMPTY', '开票信息列表-开票抬头银行', 'Invoice Information List - Invoice header bank')
export const IS_ATTACHMENT_MISSING = new CommonState('IS_ATTACHMENT_MISSING', '附件是否缺失', 'Is attachment missing')
export const COUNTER_PARTY_BILLING_NO = new CommonState('COUNTER_PARTY_BILLING_NO', '对方账单号', 'Counterparty is account number')

export const REQUIRES = new Set([
  REQUIRE_OP,
  REQUIRE_CSR,
  REQUIRE_OPDEPARTMENT,
  REQUIRE_SALES,
  REQUIRE_DOC,
  REQUIRE_DCDEPARTMENT,
  REQUIRE_DCOFFICE,
  REQUIRE_CSRDEPARTMENT,
  REQUIRE_CSROFFICE,
  REQUIRE_PLANNER,
  REQUIRE_SALES_OF_GOODS,
  REQUIRE_SITE_OP,
  REQUIRE_OPERATION_DATE,
  REQUIRE_ETD,
  REQUIRE_ETA,
  REQUIRE_ATD,
  REQUIRE_ATA,
  REQUIRE_BARGECUSTOMCUTOFF,
  REQUIRE_DELIVER_DATE,
  REQUIRE_TRANS_DATE,
  REQUIRE_ESTIMATE_WAREHOUSE_DATE,
  DESTINATION_AGENT,
  TERMINAL_CUTOFF,
  FILECUTOFF,
  REQUIRE_ARRIVAL_DATE,
  REQUIRE_DELIVERY_COMPLETION_DATE,
  REQUIRE_BL_NO,
  REQUIRE_VESSEL,
  REQUIRE_VOYAGE_NO,
  REQUIRE_FLIGHT_NO,
  REQUIRE_VOYAGE_FLIGHT,
  REQUIRE_BOOKING_AGENT,
  REQUIRE_CARRIER,
  REQUIRE_WAREHOUSE,
  REQUIRE_CARRIERAGENT,
  REQUIRE_CUSTOMS_BROKER,
  REQUIRE_CARRYING_CMP,
  REQUIRE_FORWARDING_AGENT,
  REQUIRE_LOADINGPORTCODE,
  REQUIRE_DISCHARGINGPORTCODE,
  REQUIRE_DESTINATION_PLACE,
  REQUIRE_TRADE_TERM,
  REQUIRE_INCOTERM,
  REQUIRE_CARGOSOURCE,
  REQUIRE_LOADINGTERM,
  REQUIRE_CONTAINER_LOAD_TYPE,
  REQUIRE_WAREHOUSE_NO,
  REQUIRE_PONO,
  REQUIRE_SONO,
  REQUIRE_CUSTOMER_REF_NO,
  REQUIRE_CUSTOMJOBTYPE,
  REQUIRE_GOODS_CATEGORIES,
  REQUIRE_MARK,
  REQUIRE_CARGOCHINESENAME,
  REQUIRE_CARGOENGLISHNAME,
  REQUIRE_USER_DEFINED_FIELD_1,
  REQUIRE_USER_DEFINED_FIELD_2,
  REQUIRE_USER_DEFINED_FIELD_3,
  REQUIRE_CARGO_TYPE,
  REQUIRE_ARRIVE_STORAGE_DATE,
  REQUIRE_OPERATION_CONTENT,
  REQUIRE_REMARKS,
  REQUIRE_PAYMENT_TERM_MBL,
  REQUIRE_FREIGHTTERM_HBL,
  REQUIRE_SIGNPLACE_HBL,
  REQUIRE_PAYMENTTERM_HBL,
  REQUIRE_PAYMENTPLACE_HBL,
  REQUIRE_HSCODE,
  REQUIRE_FREETIME,
  REQUIRE_CONTAINERNO,
  REQUIRE_SEALNO,
  REQUIRE_VESSELLINECODE,
  REQUIRE_SCNO,
  REQUIRE_VESSEL_IMO,
  REQUIRE_NA,
  REQUIRE_NA_CODE,
  REQUIRE_LANE_CODE,
  REQUIRE_SUB_CONTRACT_NO,
  REQUIRE_SHIPPER_LINE1,
  REQUIRE_CONSIGNEE_LINE1,
  REQUIRE_NOTIFY_LINE1,
  REQUIRE_BL_SCNADDR,
  REQUIRE_BL_CARGOENGLISHNAME,
  REQUIRE_BL_QWC,
  REQUIRE_BL_PACKING,
  REQUIRE_BL_LOADINGPORT,
  REQUIRE_BL_DISCHARGINGPORT,
  REQUIRE_BL_DESTINATIONPORT,
  REQUIRE_BL_DISPATCHINGPLACE,
  REQUIRE_BL_REMARKS,
  REQUIRE_SIGNDATE_HBL,
  REQUIRE_BOX_TYPE,
  REQUIRE_SEA_EQ,
  REQUIRE_QWC_ACTUAL,
  REQUIRE_QUANTITYCONTRACT,
  REQUIRE_WEIGHTCONTRACT,
  REQUIRE_CUBAGECONTRACT,
  REQUIRE_QUANTITY_ACTUAL,
  REQUIRE_WEIGHT_ACTUAL,
  REQUIRE_CUBAGE_ACTUAL,
  REQUIRE_QUANTITY_BOOKING,
  REQUIRE_WEIGHT_BOOKING,
  REQUIRE_CUBAGE_BOOKING,
  REQUIRE_EXCHANGE_AGENT,
  REQUIRE_CHARGE_WEIGHT,
  REQUIRE_PACKING,
  REQUIRE_SELLING_PRICE,
  REQUIRE_PB_PROPORTION,
  REQUIRE_PB_PROPORTION2,
  REQUIRE_PROFIT_RATE,
  REQUIRE_AGENT_BILLING_NO,
  REQUIRE_CHARGE_RELATED_MBL,
  REQUIRE_DOOR_TO_DOOR,
  REQUIRE_COMPREHENSIVE_TRANSPORTATION_TYPE,
  REQUIRE_DESTINATION_COUNTRY,
  REQUIRE_OVERSEA_CSR,
  REQUIRE_CUSTOMER_LEVEL,
  REQUIRE_CUSTOMER_SOURCE,
  REQUIRE_CREDIT_PAYMENT_PERIOD,
  REQUIRE_CREDIT_ADDITIONAL_DESCRIPTION,
  REQUIRE_STATISTIC_AREA,
  REQUIRE_BOX_ONE_WAY,
  REQUIRE_TRANSPORT_SOURCE,
  REQUIRE_CUSTOMER_EXPAND_MODE,
  NUMBER_PACKING_INFORMATION_PIECES,
  PACKING_INFORMATION_GROSS_WEIGHT,
  PACKING_INFORMATION_VOLUME,
  DOOR_NAME,
  REQUIRE_MBL,
  REQUIRE_USER_DEFINED_ROLE_ID1,
  REQUIRE_USER_DEFINED_ROLE_ID2,
  BILL_TAX_ACCOUNT,
  BILL_COMPANY_EMAIL,
  REQUIRE_INVOICE_TITLE,
  REQUIRE_OPENING_BANK,
  REQUIRE_BANK_ACCOUNT_NUMBER,
  REQUIRE_OUR_TITLE,
  COUNTER_PARTY_BILLING_NO,
  IS_ATTACHMENT_MISSING,
  INVOICE_NOT_EMPTY,
  CONTACT_PHONE,
  INFORMATION_INVOICE_TITLE,
  INVOICE_IDENTIFICATION_NUMBER,
  INVOICE_HEADER_BANK_NOT_EMPTY
])

export const USER_REQUIRE_CHINESE_NAME = new CommonState('CHINESE_NAME', '中文名称', 'chineseName')
export const USER_REQUIRE_CELL = new CommonState('CELL', '手机', 'cellPhone')
export const USER_REQUIRE_EXPIRATION = new CommonState('EXPIRATION', '密码失效日期', 'password expiration date')
export const USER_REQUIRE_QQ = new CommonState('QQ', 'QQ', 'QQ')
export const USER_REQUIRE_PHONE = new CommonState('PHONE', '电话', 'telephone')
export const USER_REQUIRE_FAX = new CommonState('FAX', '传真', 'fax')
export const USER_REQUIRE_MANAGER = new CommonState('MANAGER', '上级主管', 'superior supervisor')
export const USER_REQUIRE_NET_CODE = new CommonState('NET_CODE', '网管代码', 'network management code')
export const USER_REQUIRE_ENGLISH_NAME = new CommonState('ENGLISH_NAME', '英文名称', 'englishName')
export const USER_REQUIRE_DEFAULT_OFFICE_ID = new CommonState('DEFAULT_OFFICE_ID', '用户所属公司', 'the company to which the user belongs')
export const USER_REQUIRE_DEFAULT_DEP_ID = new CommonState('DEFAULT_DEP_ID', '用户所属部门', 'department to which the user belongs')
export const USER_REQUIRE_USER_CODE = new CommonState('USER_CODE', '用户代码', 'user code')

export const USER_REQUIRES = new Set([
  USER_REQUIRE_CHINESE_NAME,
  USER_REQUIRE_CELL,
  USER_REQUIRE_EXPIRATION,
  USER_REQUIRE_QQ,
  USER_REQUIRE_PHONE,
  USER_REQUIRE_FAX,
  USER_REQUIRE_MANAGER,
  USER_REQUIRE_NET_CODE,
  USER_REQUIRE_ENGLISH_NAME,
  USER_REQUIRE_DEFAULT_OFFICE_ID,
  USER_REQUIRE_DEFAULT_DEP_ID,
  USER_REQUIRE_USER_CODE
])
// ----------------
// 业务提成-岗位
// ----------------
export const COMMISSION_RULE_ROLES = new Set([
  new CommonState('', '', ''),
  REQUIRE_SALES,
  REQUIRE_CSR,
  REQUIRE_OP
])

// ----------------
// 利润
// ----------------

export const PROFIT_GROSS = new CommonState('GROSS_PROFIT', '单票毛利', 'Gross Profit')
export const PROFIT_GROSS_RATE = new CommonState('GROSS_PROFIT_RATE', '单票毛利率', 'Gross Prfit Rate')
export const TOTAL_PROFIT_GROSS = new CommonState('TOTAL_PROFIT_GROSS', '主票小票总毛利', 'Total Gross Profit Of Main Ticket And Small Ticket')
export const TOTAL_PROFIT_GROSS_RATE = new CommonState('TOTAL_PROFIT_GROSS_RATE', '主票小票总毛利率', 'Total Gross Profit Margin Of Main Ticket And Small Ticket')
export const PROFIT_USD_GROSS = new CommonState('PROFIT_USD_GROSS', '美元毛利', 'Gross profit in USD')
export const PROFIT_RMB_GROSS = new CommonState('PROFIT_RMB_GROSS', '人民币毛利', 'Gross profit in RMB')
export const PROFIT_ONE_TEU = new CommonState('PROFIT_ONE_TEU', '1TEU毛利(USD)', 'One Teu Profit(USD)')

export const PROFITS = new Set([
  PROFIT_GROSS,
  PROFIT_GROSS_RATE,
  TOTAL_PROFIT_GROSS,
  TOTAL_PROFIT_GROSS_RATE,
  PROFIT_USD_GROSS,
  PROFIT_RMB_GROSS,
  PROFIT_ONE_TEU
])

// ----------------
// 数据逻辑性
// ----------------

export const LOGIC_CHARGE_INVOICE = new CommonState('CHARGE_INVOICE', '费用未开票', 'No Invoice')
export const LOGIC_OVERSEA_CHARGE_NO_BILLING = new CommonState('NO_BILLING', '国外费用未开账单', 'No Billing')
export const LOGIC_IMPORT_DATE_RELATION = new CommonState('IMPORT_DATE_RELATION', '提货日期>换单日期>实际到港日期', '提货日期>换单日期〉实际到港日期')
export const LOGIC_CUSTOMS_BROKER = new CommonState('CUSTOMS_BROKER', '有报关服务需录入报关行', 'Customs Broker')
export const LOGIC_TRUCKING = new CommonState('TRUCKING', '有门点服务需录入车队', 'Tracking')
export const LOGIC_WAREHOUSEINFO = new CommonState('WAREHOUSEINFO', '有仓储服务需录入仓库', 'WarehouseInfo')
export const LOGIC_DESTINATIONAGENT = new CommonState('DESTINATIONAGENT', '指定货时目的港代理不能为空', 'DestinationAgent')
export const LOGIC_CONTAINERNO = new CommonState('CONTAINERNO', '箱号不能为空', 'CONTAINERNO')
export const LOGIC_SEALNO = new CommonState('SEALNO', '封号不能为空', 'SEALNO')
export const LOGIC_CUSTOMS_FILE = new CommonState('CUSTOMS_FILE', '有报关服务时必须有报关文件', 'CustomsFile')
export const LOGIC_CUSTOMS_SEND_RECORD = new CommonState('CUSTOMS_SEND_RECORD', '有报关文件时必须有报关文件送出记录', 'CustomsSendRecord')
export const LOGIC_NO_RECEIVABLE_INTERNAL_BILLING = new CommonState('NO_RECEIVABLE_INTERNAL_BILLING', '有费用未开国内应收账单', 'NoReceivableInternalBill')
export const LOGIC_NO_PAYABLE_INTERNAL_BILLING = new CommonState('NO_PAYABLE_INTERNAL_BILLING', '有费用未开国内应付账单', 'NoPayableInternalBill')
export const LOGIC_NO_RECEIVABLE_OVERSEAS_BILLING = new CommonState('NO_RECEIVABLE_OVERSEAS_BILLING', '有费用未开国外应收账单', 'NoReceivableOverseasBill')
export const LOGIC_NO_PAYABLE_OVERSEAS_BILLING = new CommonState('NO_PAYABLE_OVERSEAS_BILLING', '有费用未开国外应付账单', 'NoPayableOverseasBill')
export const LOGIC_RECEIVABLE_INTERNAL_BILL_AUDITED = new CommonState('RECEIVABLE_INTERNAL_BILL_AUDITED', '应收国内费用全部生成账单且已复核', 'ReceivableInternalBillAudited')
export const LOGIC_PAYABLE_INTERNAL_BILL_AUDITED = new CommonState('PAYABLE_INTERNAL_BILL_AUDITED', '应付国内费用全部生成账单且已复核', 'PayableInternalBillAudited')
export const LOGIC_RECEIVABLE_OVERSEAS_BILL_AUDITED = new CommonState('RECEIVABLE_OVERSEAS_BILL_AUDITED', '应收国外费用全部生成账单且已复核', 'ReceivableOverseasBillAudited')
export const LOGIC_PAYABLE_OVERSEAS_BILL_AUDITED = new CommonState('PAYABLE_OVERSEAS_BILL_AUDITED', '应付国外费用全部生成账单且已复核', 'PayableOverseasBillAudited')
export const LOGIC_REAL_ARRIVALS_DATE_VALIDITY = new CommonState('REAL_ARRIVALS_DATE_VALIDITY', '实际进港时间的有效性', 'Real Arrivals Date Validity')
export const LOGIC_CHARGE_NOT_CHECK = new CommonState('CHARGE_NOT_CHECK', '费用未审核', 'Charge Not Check')
export const LOGIC_ETD_GT_DATECREATED = new CommonState('ETD_GT_DATECREATED', '开航日期≥创建日期', 'Sailing date ≥ creation date')
/* export const LOGIC_FILE_TYPE= new CommonState("FILE_TYPE", "客户自出单文件未上传", "Customer Output Documents Not Uploaded", SystemConstants.CUSTOMER_SELF_RELEASE_STATES1);*/
export const LOGIC_FILE_TYPE = new CommonState('FILE_TYPE', '客户自出单文件已上传', 'Customer Output Documents Not Uploaded')
export const LOGIC_CUSTOMER_SELF_HBL = new CommonState('CUSTOMER_SELF_HBL', '指定货、票结业务出单类型不允许为客户自出单', 'Customers are not allowed to issue their own invoices for specified goods and tickets')

export const RECEIVABLE_CONTAIN_PAYABLE = new CommonState('RECEIVABLE_CONTAIN_PAYABLE', '应收必须包含应付', 'A / R must include a / P')
// CARGO-2606  新增验证规则配置：预提交业务才能进行提交
export const LOGIC_COMMIT_MUST_PRE = new CommonState('COMMIT_MUST_PRE', '预提交业务才能进行提交', 'commitMustPre')

// CARGO-2006 验证规则新增【电放打印】节点的控制条件
export const LOGIC_PRINT_MUST_PRE = new CommonState('PRINT_MUST_PRE', '电放打印必须上传电放保函', 'printMUSTPre')

// CARGO-5026 邦太：新增主票成本必须分摊到小票验证规则
export const MASTER_CHARGE_SHARE = new CommonState('MASTER_CHARGE_SHARE', '主票的所有成本必须要分摊到小票中', 'masterChargeShare')
// CARGO-22436 CLONE - ID：100 利通 基本配置-验证规则配置-验证项目，添加“文件类型”验证项目
export const LOGIC_DYNAMIC_FILE_TYPE = new CommonState('DYNAMIC_FILE_TYPE', '文件类型', 'File Type')
// CARGO-27319 订舱性质不为客户自订舱时订舱代理不能为空
export const LOGIC_BOOKING_TERM_BOOKING_AGENT = new CommonState('BOOKING_TERM_BOOKING_AGENT', '订舱性质为客户自订舱时订舱代理可以为空', 'bookingTermBookingAgent')
// CARGO-28378 验证规则配置模块新增【往来业务状态=预提交/已提交/已审核才能做预提交/提交】的验证项目
export const LOGIC_TRUST_JOB_STATE = new CommonState('TRUST_JOB_STATE', '委托关联业务状态', 'Delegated associated business status')
export const LOGIC_RELATED_JOB_STATE = new CommonState('RELATED_JOB_STATE', '往来关联业务状态', 'Transaction related business status')
// CARGO-27229 当装箱方式选择自拉自送后，要求业务保存时，需要验证条件：门点装箱和内装箱不能被勾选
export const LOGIC_LOCAL_SERVICES = new CommonState('LOCAL_SERVICES', '本地服务', 'localServices')
// 进仓编号
export const LOGIC_WAREHOUSE_NO = new CommonState('LOGIC_WAREHOUSE_NO', '进仓编号', 'warehouse no')
// 主票文件验证
export const LOGIC_MASTER_FILE_VERIFY = new CommonState('FILE_UPLOADED', '主票文件验证', 'Master file verify')
// 小票文件验证
export const LOGIC_SLAVE_FILE_VERIFY = new CommonState('SLAVE_FILE_VERIFY', '小票文件验证', 'Slave file verify')
// 委托拼箱一键预报验证
export const LOGIC_BB_ONE_CLICK_VERIFY = new CommonState('BB_ONE_CLICK_VERIFY', '委托拼箱一键预报验证', 'Break bulk one click forecasting verification')
// 敏感词——英文品名
export const LOGIC_SENSITIVE_WORD_ENGLISH_NAME = new CommonState('SENSITIVE_WORD_ENGLISH_NAME', '敏感词——英文品名', 'Sensitive words - English product names')
// 敏感词——中文品名
export const LOGIC_SENSITIVE_WORD_CHINESE_NAME = new CommonState('SENSITIVE_WORD_CHINESE_NAME', '敏感词——中文品名', 'Sensitive words - Chinese product names')
// 敏感词——唛头
export const LOGIC_SENSITIVE_WORD_MARK = new CommonState('SENSITIVE_WORD_MARK', '敏感词——唛头', 'Sensitive words - Mark')
// 敏感词-主单收发通第一行
export const LOGIC_SENSITIVE_WORD_COMMUNICATION_FIRST_LINE = new CommonState('LOGIC_SENSITIVE_WORD_COMMUNICATION_FIRST_LINE', '敏感词——主单收发通第一行', 'Sensitive words - Main Order Communication First Line')
// 敏感词-分单收发通第一行
export const LOGIC_SENSITIVE_WORD_HBL_COMMUNICATION_FIRST_LINE = new CommonState('LOGIC_SENSITIVE_WORD_HBL_COMMUNICATION_FIRST_LINE', '敏感词——分单收发通第一行', 'Sensitive words - Split Order Communication First Line')
// 敏感词-业务收发通第一行
export const LOGIC_SENSITIVE_WORD_JOB_COMMUNICATION_FIRST_LINE = new CommonState('LOGIC_SENSITIVE_WORD_JOB_COMMUNICATION_FIRST_LINE', '敏感词——业务收发通第一行', 'Sensitive words - Job Communication First Line')

// MANIFEST文件数等于箱量
export const LOGIC_MANIFEST_EQUAL_CONTAINER_NUM = new CommonState('MANIFEST_EQUAL_CONTAINER_NUM', 'MANIFEST文件数等于箱量', 'Manifest equal container num')
// CARGO-40165，保存增加航空公司前缀校验主单号规则验证项
export const LOGIC_AIR_MAWB_PREFIX_MATCH = new CommonState('AIR_MAWB_PREFIX_MATCH', '空运主提单号与MAWB Prefix一致', 'Air mbl prefix = MAWB Prefix')
// CARGO-41238 验证规则配置新增 数据逻辑性校验 门点页签件毛体 必须与当前业务实际件毛体一致
export const LOGIC_QUANTITY_WEIGHT_VOLUME_CONSISTENT = new CommonState('QUANTITY_WEIGHT_VOLUME_CONSISTENT', '客户门点的件毛体合计等于基本页签数据', "The total gross weight of the customer's store is equal to the basic tab data")
// 应收费用合计金额（本位币）
export const LOGIC_AR_CHARGE_LOCAL_TOTAL = new CommonState('AR_CHARGE_LOCAL_TOTAL', '应收费用合计金额（本位币）', 'Receivable charge total(local currency)')
// 应付费用合计金额（本位币）
export const LOGIC_AP_CHARGE_LOCAL_TOTAL = new CommonState('AP_CHARGE_LOCAL_TOTAL', '应付费用合计金额（本位币）', 'Payable charge total(local currency)')
// CRM客户中文名
export const LOGIC_CRM_CUSTOMER_CHINESE_NAME = new CommonState('CRM_CUSTOMER_CHINESE_NAME', 'CRM客户中文名', 'CRM customer chinese name')
// CRM客户英文名
export const LOGIC_CRM_CUSTOMER_ENGLISH_NAME = new CommonState('CRM_CUSTOMER_ENGLISH_NAME', 'CRM客户英文名', 'CRM customer english name')
// 实际件数
export const REQUIRE_ACTUAL_QUANTITY = new CommonState('ACTUAL_QUANTITY', '实际件数', 'Actual quantity')
// 实际件数
export const REQUIRE_ENTRUST_QUANTITY = new CommonState('ENTRUST_QUANTITY', '委托件数', 'Number of entrusted items')
// 实际件数
export const REQUIRE_DOCUMENT_PREPARATION_QUANTITY = new CommonState('DOCUMENT_PREPARATION_QUANTITY', '制单件数', 'Number of production orders')
//
export const CONSISTENT_EXPENSE_ENTRY = new CommonState('CONSISTENT_EXPENSE_ENTRY', '退关操作人是否与业务的所有费用录入人一致', 'Is the person handling the customs clearance consistent with the person responsible for recording all business expenses')
// CARGO-41654, 新增验证规则 数据逻辑性
export const LOGIC_DATECREATED_LT_ATD = new CommonState('DATECREATED_LT_ATD', '创建时间≤实际运输开始时间(ATD)', 'creation date ≤  Actual Sailing start date(ATD)')
export const LOGIC_CURRENT_TIME_GT_ATD = new CommonState('CURRENT_TIME_GT_ATD', '当前时间≥实际运输开始时间(ATD)', 'current time ≥ Actual Sailing start date(ATD)')
export const ONLY_ONE_CUSTOMS_DECLARATION = new CommonState('ONLY_ONE_CUSTOMS_DECLARATION', '仅允许创建一个报关委托', 'Only one customs declaration commission is allowed to be created')
export const LOGIC_NOT_MATCHING_CHARGE_MAPPING = new CommonState('NOT_MATCHING_CHARGE_MAPPING', '新增费用名称未绑定费用组', 'New charge name not bound to charge group')
export const LOGIC_AP_CHARGE_ACCOUNT_ID_NOT_UNIQUE = new CommonState('LOGIC_AP_CHARGE_ACCOUNT_ID_NOT_UNIQUE', '应付费用结算对象不唯一', 'Expenses payable to more than one person')
export const AR_CONTAIN_AP_NO_AMOUNT = new CommonState('AR_CONTAIN_AP_NO_AMOUNT（不含金额校验）', '应收必须包含应付（不含金额校验）', 'A / R must include a / P (without amount verification)')
export const UNIQUE_CHARGE_AP_NO_REMARK = new CommonState('UNIQUE_CHARGE_AP_NO_REMARK', '不对应的应付费用没有填写费用备注', 'No expense notes have been filled in for non-corresponding expenses payable')
export const CONFIRM_OF_RECEIVABLE = new CommonState('CONFIRM_OF_RECEIVABLE', '应收费用是否全部确认', 'Have all receivable expenses been confirmed')
export const CONFIRM_OF_PAYABLE = new CommonState('CONFIRM_OF_PAYABLE', '应付费用是否全部确认', 'Have all payable expenses been confirmed')
export const RECEIVABLE_CHARGE_NOT_CHECK = new CommonState('RECEIVABLE_CHARGE_NOT_CHECK', '应收费用未审核', 'Receivable Charge Not Check')
export const PAYABLE_CHARGE_NOT_CHECK = new CommonState('PAYABLE_CHARGE_NOT_CHECK', '应付费用未审核', 'Payable Charge Not Check')
export const PAYABLE_CHARGE_ALL_VERIFIED = new CommonState('PAYABLE_CHARGE_ALL_VERIFIED', '应付费用全部核销', 'Payable Charge All Verified')
export const RECEIVABLE_CHARGE_ALL_VERIFIED = new CommonState('RECEIVABLE_CHARGE_ALL_VERIFIED', '应收费用全部核销', 'Receivable Charge All Verified')
export const RECEIVABLE_CONTAIN_PAYABLE_RATE_SAME = new CommonState('RECEIVABLE_CONTAIN_PAYABLE_RATE_SAME', '应收必须包含应付（汇率一致）', 'A / R must include a / P (Same exchange rate)')
export const CONTAINER_WITH_CONTAINERNO_NEED_QWC = new CommonState('CONTAINER_WITH_CONTAINERNO_NEED_QWC', '有箱号的箱子需填写件毛体', 'Container with container no need to fill with weight/quantity/cubage')
export const DOOR_POINT_SERVICE_CHECK_INFORMATION = new CommonState('DOOR_POINT_SERVICE_CHECK_INFORMATION', '有门点服务需录入门点名称', 'Service points require entry of service point names')
export const DOOR_POINT_SERVICE_CHECK_EXPECTED_PACKING_DATE = new CommonState('DOOR_POINT_SERVICE_CHECK_EXPECTED_PACKING_DATE', '有门点服务需录入预计装箱日期', 'Service points require the entry of the estimated packing date')
export const DOOR_POINT_SERVICE_CHECK_ADDRESSES = new CommonState('DOOR_POINT_SERVICE_CHECK_ADDRESSES', '有门点服务需录入门点地址', 'Service points require the entry of service point addresses')
export const DOOR_POINT_SERVICE_CHECK_CONTACT_PERSONS = new CommonState('DOOR_POINT_SERVICE_CHECK_CONTACT_PERSONS', '有门点服务需录入联系人', 'Service points require the entry of contact persons')
export const DOOR_POINT_SERVICE_CHECK_DECLARATION_TYPES = new CommonState('DOOR_POINT_SERVICE_CHECK_DECLARATION_TYPES', '有报关服务需录入报关类型', 'Customs services require the entry of customs declaration types')
// CARGO-46199 货物明细件毛体与基本页签一致
export const LOGIC_TRADE_DETAIL_QUANTITY_WEIGHT_VOLUME_CONSISTENT = new CommonState('TRADE_DETAIL_QUANTITY_WEIGHT_VOLUME_CONSISTENT', '货物明细件毛体与基本页签一致', 'The gross body of the goods details is consistent with the basic tab')
// CARGO-50888
export const LOGIC_TRADE_DETAIL_QUANTITY_WEIGHT_VOLUME_CONSISTENT_ACTUAL_OR_CONSIGNED = new CommonState('TRADE_DETAIL_QUANTITY_WEIGHT_VOLUME_CONSISTENT_ACTUAL_OR_CONSIGNED', '货物明细件毛体与基本页签（实际/委托）一致', 'The cargo details (PCS/G.W./VOL) match the basic tab (actual/consigned).')

export const MANDATORY_VOUCHER_NUMBER = new CommonState('MANDATORY_VOUCHER_NUMBER', '导入费用销账-必填凭证号', 'Import expense write-off - mandatory voucher number')
export const DUPLICATE_ROW_REMINDER = new CommonState('DUPLICATE_ROW_REMINDER', '导入费用销账-重复行提醒', 'Import expense write-off - duplicate row reminder')

// CARGO-46358 新增远程订舱保存校验条件
export const CHECK_DOOR_AND_ADDRESS = new CommonState('CHECK_DOOR_AND_ADDRESS', '有目的港派车服务时必录门点和地址', 'Destination port delivery door point and address')
// CARGO-47262 P1-欧坚业务保存时，校验9个点的费用税率（税率69倒挂需求）
export const LOGIC_CHARGE_AR_AP_NINE_TAX_RATE = new CommonState('CHARGE_AR_AP_NINE_TAX_RATE', '9%税率的应收和应付项目必须同时存在', 'Items receivable and payable at the 9% tax rate must exist simultaneously')

// CARGO-4726 费用的发票复核状态
export const LOGIC_CHARGE_INVOICE_REVIEW_STATE = new CommonState('CHARGE_INVOICE_REVIEW_STATE', '费用的发票复核状态', 'Invoice review status of expenses')

// CARGO-4713  成本类型必须相同
export const CHARGE_COST_TYPE_NOT_EMPTY = new CommonState('CHARGE_COST_TYPE_NOT_EMPTY', '应付费用的成本类型不能为空', 'The cost type of payable expenses cannot be empty')
export const LOGIC_CHARGE_COST_TYPE_SAME = new CommonState('CHARGE_COST_TYPE_SAME', '应付费用的成本类型不能为空且必须相同', 'The cost type of payable expenses cannot be empty and must be the same')
// 委托单位范围
export const LOGIC_CONSIGNATION_COMPANY_SCOPE = new CommonState('CONSIGNATION_COMPANY_SCOPE', '委托单位范围', 'Consignation company scope')
// 应收结算对象范围
export const LOGIC_RECEIVABLE_ACCOUNT_OBJECT_SCOPE = new CommonState('RECEIVABLE_ACCOUNT_OBJECT_SCOPE', '应收结算对象范围', 'Receivable account object scope')
// 二级自定义业务类型出现时需录入
export const SECONDARY_SERVICE_TYPE_REQUIRE = new CommonState('SECONDARY_SERVICE_TYPE_REQUIRE', '二级自定义业务类型出现时需录入', 'Secondary service type require')
// 有协作分公司需要验证所有协作业务状态
export const COOPERATIVE_BUSINESS_STATE_CHECK = new CommonState('COOPERATIVE_BUSINESS_STATE_CHECK', '协作业务状态全部为【已完成】', 'cooperative business state check')
// 账单费用全部已确认
export const BILLING_CHARGE_CONFIRM_STATE_CHECK = new CommonState('BILLING_CHARGE_CONFIRM_STATE_CHECK', '账单中费用已全部确认', 'Billing charge has been confirmed')
// 操作分公司是否与销售分公司不一致
export const LOGIC_OP_SALES_OFFICES_DIFFERENT = new CommonState('OP_SALES_OFFICES_DIFFERENT', '操作分公司是否与销售分公司不一致', 'Is the operation branch company inconsistent with the sales branch company')

// PILL-1056
export const LOGIC_MBL_CONTAINER_TOTAL_MATCH = new CommonState('MBL_CONTAINER_TOTAL_MATCH', 'MBL件毛体与装箱件毛体一致', 'MBL body is consistent with packing body')
// 勾选了HBL时，目的港代理必填
export const LOGIC_HBL_SELECTED_DESTINATION_PORT_REQUIRE = new CommonState('HBL_SELECTED_DESTINATION_PORT_REQUIRE', '勾选了HBL时，目的港代理必填', 'When HBL is selected, the destination port agent must be filled in')
// 货物明细-英文品名
export const LOGIC_TRADE_DETAIL_ENGLISH_NAME = new CommonState('TRADE_DETAIL_ENGLISH_NAME', '货物明细-英文品名', 'Trade detail-English name')
// 货物明细-包装
export const LOGIC_TRADE_DETAIL_PACK = new CommonState('TRADE_DETAIL_PACK', '货物明细-包装', 'Trade detail-Pack')
// 货物明细-包装显示名
export const LOGIC_TRADE_DETAIL_PACK_NAME = new CommonState('TRADE_DETAIL_PACK_NAME', '货物明细-包装显示名', 'Trade detail-Pack name')
// 货物明细-HS CODE
export const LOGIC_TRADE_DETAIL_HSCODE = new CommonState('TRADE_DETAIL_HSCODE', '货物明细-HS CODE', 'Trade detail-HS CODE')
// 货物明细-唛头
export const LOGIC_TRADE_DETAIL_MARK = new CommonState('TRADE_DETAIL_MARK', '货物明细-唛头', 'Trade detail-Mark')
// 化工品-CUS CODE
export const LOGIC_CHEMICAL_PRODUCT_CUS_CODE = new CommonState('CHEMICAL_PRODUCT_CUS_CODE', '化工品-CUS CODE', 'Chemical product-CUS CODE')
// HBL并单时提单合计件毛体与提单保持一致
export const HBL_MERGES_KEEP_UP_WITH_WEIGHT = new CommonState('HBL_MERGES_KEEP_UP_WITH_WEIGHT', 'HBL并单时提单合计件毛体与提单保持一致', 'When HBL merges, the total weight of the bill of lading should be consistent with the bill of lading')
// HBL拆单时提单合计件毛体与提单保持一致
export const HBL_SPLITS_KEEP_UP_WITH_WEIGHT = new CommonState('HBL_SPLITS_KEEP_UP_WITH_WEIGHT', 'HBL拆单时提单合计件毛体与提单保持一致', 'When HBL splits the bill of lading, the total weight of the bill of lading should be consistent with the bill of lading')
// 是否勾选HBL
export const REQUIRE_CHECKED_HBL = new CommonState('REQUIRE_CHECKED_HBL', '是否勾选HBL', ' HBL Checked')
// 申请放单状态
export const LOGIC_APPLICATION_STATUS_FOR_RELEASE = new CommonState('LOGIC_APPLICATION_STATUS_FOR_RELEASE', '申请放单状态', 'Application Status for Release')
// 已申请
export const LOGIC_APPLIED = new CommonState('LOGIC_APPLIED', '已申请', 'applied')
// 未申请
export const LOGIC_NOT_APPLIED = new CommonState('LOGIC_NOT_APPLIED', '未申请', 'not applied')
// 应收结算对象客户编码13位
export const LOGIC_AR_ACCOUNT_CUSTOMER_CODE = new CommonState('LOGIC_AR_ACCOUNT_CUSTOMER_CODE', '应收结算对象客户编码13位', 'The customer code for the receivables settlement object is 13 digits')
// 委托单位范围（已有费用录入时）
export const CLIENT_SCOPE_HAVE_CHARGE = new CommonState('CLIENT_SCOPE_HAVE_CHARGE', '委托单位范围（已有费用录入时）', 'Scope of entrusted units (when expenses have already been entered)')
// 合并展示费用需要同时存在、币种数量一致
export const LOGIC_MERGE_DISPLAY_FEES_NEED = new CommonState('MERGE_DISPLAY_FEES_NEED', '合并展示费用需要同时存在、币种数量一致', 'Merge display fees need to exist simultaneously and have the same number of currencies')
// CARGO-50589 柏淼：业务保存时操作、销售相同不弹窗提示
export const SALES_AND_OPERATIONS_DIFFER = new CommonState('SALES_AND_OPERATIONS_DIFFER', '销售、操作是否相同', 'Are sales and operations identical in function')
export const REQUIRE_AR_CHARGE_RATE = new CommonState('AR_CHARGE_RATE', '应收费用税率', 'Ar charge rate')
export const REQUIRE_AP_CHARGE_RATE = new CommonState('AP_CHARGE_RATE', '应付费用税率', 'Ap charge rate')
export const LOGIC_INVOICE_NATURE = new CommonState('INVOICE_NATURE', '税率标识', 'Tax Rate Mark')
export const INVOICE_HEADER_NOT_DUPLICATED = new CommonState('INVOICE_HEADER_NOT_DUPLICATED', '开票抬头不可重复', 'Invoice header cannot be duplicated')
export const LOGIC_INVOICE_TAX_NATURE_SAME = new CommonState('INVOICE_TAX_NATURE_SAME', '税务性质是否相同', 'Are the tax natures the same')
export const LOGIC_UNIQUE_BUSINESS_REFERENCE_NUMBER = new CommonState('LOGIC_UNIQUE_BUSINESS_REFERENCE_NUMBER', '业务参考号唯一', 'Unique business reference number')

export const LOGICS = new Set([
  LOGIC_CHARGE_INVOICE,
  LOGIC_OVERSEA_CHARGE_NO_BILLING,
  LOGIC_IMPORT_DATE_RELATION,
  LOGIC_CUSTOMS_BROKER,
  LOGIC_TRUCKING,
  LOGIC_WAREHOUSEINFO,
  LOGIC_DESTINATIONAGENT,
  LOGIC_CONTAINERNO,
  LOGIC_SEALNO,
  LOGIC_CUSTOMS_FILE,
  LOGIC_CUSTOMS_SEND_RECORD,
  LOGIC_NO_RECEIVABLE_INTERNAL_BILLING,
  LOGIC_NO_PAYABLE_INTERNAL_BILLING,
  LOGIC_NO_RECEIVABLE_OVERSEAS_BILLING,
  LOGIC_NO_PAYABLE_OVERSEAS_BILLING,
  LOGIC_RECEIVABLE_INTERNAL_BILL_AUDITED,
  LOGIC_PAYABLE_INTERNAL_BILL_AUDITED,
  LOGIC_RECEIVABLE_OVERSEAS_BILL_AUDITED,
  LOGIC_PAYABLE_OVERSEAS_BILL_AUDITED,
  LOGIC_REAL_ARRIVALS_DATE_VALIDITY,
  LOGIC_CHARGE_NOT_CHECK,
  LOGIC_ETD_GT_DATECREATED,
  LOGIC_FILE_TYPE,
  LOGIC_CUSTOMER_SELF_HBL,
  RECEIVABLE_CONTAIN_PAYABLE,
  LOGIC_COMMIT_MUST_PRE,
  LOGIC_PRINT_MUST_PRE,
  MASTER_CHARGE_SHARE,
  LOGIC_DYNAMIC_FILE_TYPE,
  LOGIC_BOOKING_TERM_BOOKING_AGENT,
  LOGIC_TRUST_JOB_STATE,
  LOGIC_RELATED_JOB_STATE,
  LOGIC_LOCAL_SERVICES,
  LOGIC_WAREHOUSE_NO,
  CHARGEABLE_WEIGHT_RT,
  MBL_CANNOT_REPEATED,
  LOGIC_MASTER_FILE_VERIFY,
  LOGIC_SLAVE_FILE_VERIFY,
  LOGIC_BB_ONE_CLICK_VERIFY,
  LOGIC_SENSITIVE_WORD_ENGLISH_NAME,
  LOGIC_SENSITIVE_WORD_CHINESE_NAME,
  LOGIC_SENSITIVE_WORD_MARK,
  LOGIC_SENSITIVE_WORD_COMMUNICATION_FIRST_LINE,
  LOGIC_SENSITIVE_WORD_HBL_COMMUNICATION_FIRST_LINE,
  LOGIC_SENSITIVE_WORD_JOB_COMMUNICATION_FIRST_LINE,
  LOGIC_MANIFEST_EQUAL_CONTAINER_NUM,
  LOGIC_AIR_MAWB_PREFIX_MATCH,
  LOGIC_QUANTITY_WEIGHT_VOLUME_CONSISTENT,
  LOGIC_AR_CHARGE_LOCAL_TOTAL,
  LOGIC_AP_CHARGE_LOCAL_TOTAL,
  LOGIC_CRM_CUSTOMER_CHINESE_NAME,
  LOGIC_CRM_CUSTOMER_ENGLISH_NAME,
  REQUIRE_ACTUAL_QUANTITY,
  REQUIRE_ENTRUST_QUANTITY,
  REQUIRE_DOCUMENT_PREPARATION_QUANTITY,
  CONSISTENT_EXPENSE_ENTRY,
  LOGIC_DATECREATED_LT_ATD,
  LOGIC_CURRENT_TIME_GT_ATD,
  ONLY_ONE_CUSTOMS_DECLARATION,
  LOGIC_NOT_MATCHING_CHARGE_MAPPING,
  LOGIC_AP_CHARGE_ACCOUNT_ID_NOT_UNIQUE,
  AR_CONTAIN_AP_NO_AMOUNT,
  UNIQUE_CHARGE_AP_NO_REMARK,
  CONFIRM_OF_RECEIVABLE,
  CONFIRM_OF_PAYABLE,
  RECEIVABLE_CHARGE_NOT_CHECK,
  PAYABLE_CHARGE_NOT_CHECK,
  PAYABLE_CHARGE_ALL_VERIFIED,
  RECEIVABLE_CHARGE_ALL_VERIFIED,
  RECEIVABLE_CONTAIN_PAYABLE_RATE_SAME,
  CONTAINER_WITH_CONTAINERNO_NEED_QWC,
  DOOR_POINT_SERVICE_CHECK_INFORMATION,
  DOOR_POINT_SERVICE_CHECK_EXPECTED_PACKING_DATE,
  DOOR_POINT_SERVICE_CHECK_ADDRESSES,
  DOOR_POINT_SERVICE_CHECK_CONTACT_PERSONS,
  DOOR_POINT_SERVICE_CHECK_DECLARATION_TYPES,
  CHECK_DOOR_AND_ADDRESS,
  MANDATORY_VOUCHER_NUMBER,
  DUPLICATE_ROW_REMINDER,
  LOGIC_TRADE_DETAIL_QUANTITY_WEIGHT_VOLUME_CONSISTENT,
  LOGIC_CHARGE_AR_AP_NINE_TAX_RATE,
  LOGIC_HBL_SELECTED_DESTINATION_PORT_REQUIRE,
  LOGIC_CHARGE_INVOICE_REVIEW_STATE,
  CHARGE_COST_TYPE_NOT_EMPTY,
  LOGIC_CHARGE_COST_TYPE_SAME,
  LOGIC_TRADE_DETAIL_QUANTITY_WEIGHT_VOLUME_CONSISTENT,
  LOGIC_TRADE_DETAIL_QUANTITY_WEIGHT_VOLUME_CONSISTENT_ACTUAL_OR_CONSIGNED,
  LOGIC_CONSIGNATION_COMPANY_SCOPE,
  LOGIC_RECEIVABLE_ACCOUNT_OBJECT_SCOPE,
  SECONDARY_SERVICE_TYPE_REQUIRE,
  COOPERATIVE_BUSINESS_STATE_CHECK,
  BILLING_CHARGE_CONFIRM_STATE_CHECK,
  LOGIC_OP_SALES_OFFICES_DIFFERENT,
  LOGIC_TRADE_DETAIL_ENGLISH_NAME,
  LOGIC_TRADE_DETAIL_PACK,
  LOGIC_TRADE_DETAIL_PACK_NAME,
  LOGIC_TRADE_DETAIL_HSCODE,
  LOGIC_TRADE_DETAIL_MARK,
  LOGIC_CHEMICAL_PRODUCT_CUS_CODE,
  HBL_MERGES_KEEP_UP_WITH_WEIGHT,
  HBL_SPLITS_KEEP_UP_WITH_WEIGHT,
  REQUIRE_CHECKED_HBL,
  LOGIC_AR_ACCOUNT_CUSTOMER_CODE,
  LOGIC_APPLICATION_STATUS_FOR_RELEASE,
  CLIENT_SCOPE_HAVE_CHARGE,
  LOGIC_MERGE_DISPLAY_FEES_NEED,
  SALES_AND_OPERATIONS_DIFFER,
  REQUIRE_AR_CHARGE_RATE,
  REQUIRE_AP_CHARGE_RATE,
  LOGIC_INVOICE_NATURE,
  LOGIC_INVOICE_TAX_NATURE_SAME,
  LOGIC_UNIQUE_BUSINESS_REFERENCE_NUMBER,
  INVOICE_HEADER_NOT_DUPLICATED
])

// ----------------
// 数据变更
// ----------------

export const DATA_CHANGED_ETD = new CommonState('ETD', '开航日期', 'Etd')
export const DATA_CHANGED_SEAEQ = new CommonState('SEAEQ', '箱型箱量', 'SeaEQ')
export const DATA_CHANGED_SHUT_OUT = new CommonState('SHUT_OUT', '退关', 'ShutOut')
export const DATA_CHANGED_DISCHARGINGPORT = new CommonState('DISCHARGING_PORT', '卸货港', 'dischargingPort')
export const DATA_CHANGED_DESTINATION_PORT = new CommonState('DESTINATION_PORT', '交货地', 'DestinationPort')
export const DATA_CHANGED_FREIGHT_TERM = new CommonState('FREIGHT_TERM', '主单运输条款', 'freightTerm')
export const DATA_CHANGED_SHIPPER = new CommonState('SHIPPER', '发货人', 'shipper')
export const DATA_CHANGED_SHIPPER_ADDR = new CommonState('SHIPPER_ADDR', '发货人信息', 'shipperAddr')
export const DATA_CHANGED_VESSEL = new CommonState('VESSEL', '船名', 'Vessel')
export const DATA_CHANGED_VOYAGE_NO = new CommonState('VOYAGE_NO', '航次', 'Voyage No')

export const DATA_CHANGES = new Set([
  DATA_CHANGED_ETD,
  DATA_CHANGED_SEAEQ,
  DATA_CHANGED_SHUT_OUT,
  DATA_CHANGED_DISCHARGINGPORT,
  DATA_CHANGED_DESTINATION_PORT,
  DATA_CHANGED_FREIGHT_TERM,
  DATA_CHANGED_SHIPPER,
  DATA_CHANGED_SHIPPER_ADDR,
  DATA_CHANGED_VESSEL,
  DATA_CHANGED_VOYAGE_NO
])

// ----------------
// All
// ----------------

export const EXPRESSION_DIMENSIONS = new Set([
  REQUIRE_OP,
  REQUIRE_CSR,
  REQUIRE_OPDEPARTMENT,
  REQUIRE_SALES,
  REQUIRE_DOC,
  REQUIRE_DCDEPARTMENT,
  REQUIRE_DCOFFICE,
  REQUIRE_CSRDEPARTMENT,
  REQUIRE_CSROFFICE,
  REQUIRE_CARGOSOURCE,
  REQUIRE_BL_NO,
  REQUIRE_VESSEL,
  REQUIRE_VOYAGE_NO,
  REQUIRE_FLIGHT_NO,
  REQUIRE_PONO,
  REQUIRE_ETA,
  REQUIRE_ETD,
  REQUIRE_ATA,
  REQUIRE_DELIVER_DATE,
  REQUIRE_TRANS_DATE,
  REQUIRE_ESTIMATE_WAREHOUSE_DATE,
  REQUIRE_BOOKING_AGENT,
  REQUIRE_CARRIER,
  REQUIRE_WAREHOUSE,
  REQUIRE_SONO,
  REQUIRE_QWC_ACTUAL,
  REQUIRE_SEA_EQ,
  REQUIRE_LOADINGPORTCODE,
  REQUIRE_DISCHARGINGPORTCODE,
  REQUIRE_BARGECUSTOMCUTOFF,
  REQUIRE_VESSELLINECODE,
  REQUIRE_CARGOCHINESENAME,
  REQUIRE_CARGOENGLISHNAME,
  REQUIRE_QUANTITYCONTRACT,
  REQUIRE_WEIGHTCONTRACT,
  REQUIRE_CUBAGECONTRACT,
  REQUIRE_FREIGHTTERM_HBL,
  REQUIRE_SIGNPLACE_HBL,
  REQUIRE_PAYMENTTERM_HBL,
  REQUIRE_PAYMENTPLACE_HBL,
  REQUIRE_SIGNDATE_HBL,
  REQUIRE_BL_SCNADDR,
  REQUIRE_BL_REMARKS,
  REQUIRE_BL_CARGOENGLISHNAME,
  REQUIRE_BL_QWC,
  REQUIRE_BL_PACKING,
  REQUIRE_BL_LOADINGPORT,
  REQUIRE_BL_DISCHARGINGPORT,
  REQUIRE_BL_DESTINATIONPORT,
  REQUIRE_BL_DISPATCHINGPLACE,
  REQUIRE_PROFIT_RATE,
  REQUIRE_LOADINGTERM,
  REQUIRE_SELLING_PRICE,
  REQUIRE_CUSTOMER_REF_NO,
  REQUIRE_CUSTOMJOBTYPE,
  REQUIRE_GOODS_CATEGORIES,
  REQUIRE_INCOTERM,
  REQUIRE_PLANNER,
  REQUIRE_CARRIERAGENT,
  REQUIRE_SCNO,
  PROFIT_GROSS,
  PROFIT_GROSS_RATE,
  TOTAL_PROFIT_GROSS,
  TOTAL_PROFIT_GROSS_RATE,
  PROFIT_USD_GROSS,
  PROFIT_RMB_GROSS,
  LOGIC_CHARGE_INVOICE,
  LOGIC_OVERSEA_CHARGE_NO_BILLING,
  LOGIC_IMPORT_DATE_RELATION,
  LOGIC_CUSTOMS_BROKER,
  LOGIC_TRUCKING,
  LOGIC_WAREHOUSEINFO,
  LOGIC_DESTINATIONAGENT,
  LOGIC_CONTAINERNO,
  LOGIC_SEALNO,
  LOGIC_CUSTOMS_FILE,
  LOGIC_CUSTOMS_SEND_RECORD,
  LOGIC_NO_RECEIVABLE_INTERNAL_BILLING,
  LOGIC_NO_PAYABLE_INTERNAL_BILLING,
  LOGIC_NO_RECEIVABLE_OVERSEAS_BILLING,
  LOGIC_NO_PAYABLE_OVERSEAS_BILLING,
  LOGIC_RECEIVABLE_INTERNAL_BILL_AUDITED,
  LOGIC_PAYABLE_INTERNAL_BILL_AUDITED,
  LOGIC_RECEIVABLE_OVERSEAS_BILL_AUDITED,
  LOGIC_PAYABLE_OVERSEAS_BILL_AUDITED,
  LOGIC_REAL_ARRIVALS_DATE_VALIDITY,
  LOGIC_CHARGE_NOT_CHECK,
  LOGIC_ETD_GT_DATECREATED,
  LOGIC_FILE_TYPE,
  LOGIC_CUSTOMER_SELF_HBL,
  DATA_CHANGED_ETD,
  DATA_CHANGED_SEAEQ,
  DATA_CHANGED_SHUT_OUT,
  DATA_CHANGED_DISCHARGINGPORT,
  DATA_CHANGED_DESTINATION_PORT,
  DATA_CHANGED_FREIGHT_TERM,
  DATA_CHANGED_SHIPPER,
  DATA_CHANGED_SHIPPER_ADDR,
  REQUIRE_HSCODE,
  REQUIRE_FREETIME,
  REQUIRE_CONTAINERNO,
  REQUIRE_SEALNO,
  REQUIRE_USER_DEFINED_FIELD_1,
  REQUIRE_USER_DEFINED_FIELD_2,
  REQUIRE_USER_DEFINED_FIELD_3,
  REQUIRE_CARGO_TYPE,
  REQUIRE_ARRIVE_STORAGE_DATE,
  REQUIRE_SHIPPER_LINE1,
  REQUIRE_CONSIGNEE_LINE1,
  RECEIVABLE_CONTAIN_PAYABLE,
  REQUIRE_AGENT_BILLING_NO,
  LOGIC_COMMIT_MUST_PRE,
  LOGIC_PRINT_MUST_PRE,
  LOGIC_TRUST_JOB_STATE,
  LOGIC_RELATED_JOB_STATE,
  REQUIRE_PACKING,
  REQUIRE_PB_PROPORTION,
  REQUIRE_PB_PROPORTION2,
  DESTINATION_AGENT,
  TERMINAL_CUTOFF,
  FILECUTOFF,
  REQUIRE_ATD,
  REQUIRE_SALES_OF_GOODS,
  REQUIRE_DELIVERY_COMPLETION_DATE,
  MASTER_CHARGE_SHARE,
  REQUIRE_CONTAINER_LOAD_TYPE,
  REQUIRE_CUSTOMS_BROKER,
  REQUIRE_CARRYING_CMP,
  REQUIRE_QUANTITY_ACTUAL,
  REQUIRE_WEIGHT_ACTUAL,
  REQUIRE_CUBAGE_ACTUAL,
  REQUIRE_QUANTITY_BOOKING,
  REQUIRE_WEIGHT_BOOKING,
  REQUIRE_CUBAGE_BOOKING,
  REQUIRE_NOTIFY_LINE1,
  REQUIRE_EXCHANGE_AGENT,
  REQUIRE_BOX_TYPE,
  REQUIRE_DESTINATION_PLACE,
  REQUIRE_PAYMENT_TERM_MBL,
  REQUIRE_MARK,
  REQUIRE_FORWARDING_AGENT,
  LOGIC_DYNAMIC_FILE_TYPE,
  REQUIRE_CHARGE_WEIGHT,
  REQUIRE_TRADE_TERM,
  LOGIC_BOOKING_TERM_BOOKING_AGENT,
  LOGIC_LOCAL_SERVICES,
  REQUIRE_WAREHOUSE_NO,
  LOGIC_WAREHOUSE_NO,
  LOGIC_MASTER_FILE_VERIFY,
  LOGIC_SLAVE_FILE_VERIFY,
  LOGIC_BB_ONE_CLICK_VERIFY,
  LOGIC_SENSITIVE_WORD_ENGLISH_NAME,
  LOGIC_SENSITIVE_WORD_CHINESE_NAME,
  LOGIC_SENSITIVE_WORD_MARK,
  LOGIC_SENSITIVE_WORD_COMMUNICATION_FIRST_LINE,
  LOGIC_SENSITIVE_WORD_HBL_COMMUNICATION_FIRST_LINE,
  LOGIC_SENSITIVE_WORD_JOB_COMMUNICATION_FIRST_LINE,
  LOGIC_MANIFEST_EQUAL_CONTAINER_NUM,
  LOGIC_AIR_MAWB_PREFIX_MATCH,
  LOGIC_QUANTITY_WEIGHT_VOLUME_CONSISTENT,
  LOGIC_AR_CHARGE_LOCAL_TOTAL,
  LOGIC_AP_CHARGE_LOCAL_TOTAL,
  LOGIC_CRM_CUSTOMER_CHINESE_NAME,
  LOGIC_CRM_CUSTOMER_ENGLISH_NAME,
  REQUIRE_ACTUAL_QUANTITY,
  REQUIRE_ENTRUST_QUANTITY,
  REQUIRE_DOCUMENT_PREPARATION_QUANTITY,
  CONSISTENT_EXPENSE_ENTRY,
  REQUIRE_OPERATION_CONTENT,
  REQUIRE_REMARKS,
  REQUIRE_VESSEL_IMO,
  REQUIRE_NA,
  REQUIRE_NA_CODE,
  REQUIRE_LANE_CODE,
  REQUIRE_SUB_CONTRACT_NO,
  REQUIRE_SITE_OP,
  REQUIRE_VOYAGE_FLIGHT,
  REQUIRE_CHARGE_RELATED_MBL,
  PROFIT_ONE_TEU,
  REQUIRE_DOOR_TO_DOOR,
  REQUIRE_OPERATION_DATE,
  REQUIRE_ARRIVAL_DATE,
  REQUIRE_COMPREHENSIVE_TRANSPORTATION_TYPE,
  REQUIRE_DESTINATION_COUNTRY,
  REQUIRE_OVERSEA_CSR,
  REQUIRE_CUSTOMER_LEVEL,
  REQUIRE_CUSTOMER_SOURCE,
  REQUIRE_CREDIT_PAYMENT_PERIOD,
  REQUIRE_CREDIT_ADDITIONAL_DESCRIPTION,
  REQUIRE_STATISTIC_AREA,
  REQUIRE_BOX_ONE_WAY,
  LOGIC_DATECREATED_LT_ATD,
  LOGIC_CURRENT_TIME_GT_ATD,
  ONLY_ONE_CUSTOMS_DECLARATION,
  LOGIC_AP_CHARGE_ACCOUNT_ID_NOT_UNIQUE,
  AR_CONTAIN_AP_NO_AMOUNT,
  REQUIRE_TRANSPORT_SOURCE,
  REQUIRE_CUSTOMER_EXPAND_MODE,
  CONFIRM_OF_RECEIVABLE,
  CONFIRM_OF_PAYABLE,
  NUMBER_PACKING_INFORMATION_PIECES,
  PACKING_INFORMATION_GROSS_WEIGHT,
  PACKING_INFORMATION_VOLUME,
  DOOR_NAME,
  RECEIVABLE_CHARGE_NOT_CHECK,
  PAYABLE_CHARGE_NOT_CHECK,
  PAYABLE_CHARGE_ALL_VERIFIED,
  RECEIVABLE_CHARGE_ALL_VERIFIED,
  RECEIVABLE_CONTAIN_PAYABLE_RATE_SAME,
  CONTAINER_WITH_CONTAINERNO_NEED_QWC,
  DOOR_POINT_SERVICE_CHECK_INFORMATION,
  DOOR_POINT_SERVICE_CHECK_EXPECTED_PACKING_DATE,
  DOOR_POINT_SERVICE_CHECK_ADDRESSES,
  DOOR_POINT_SERVICE_CHECK_CONTACT_PERSONS,
  DOOR_POINT_SERVICE_CHECK_DECLARATION_TYPES,
  CHECK_DOOR_AND_ADDRESS,
  MANDATORY_VOUCHER_NUMBER,
  DUPLICATE_ROW_REMINDER,
  LOGIC_TRADE_DETAIL_QUANTITY_WEIGHT_VOLUME_CONSISTENT,
  LOGIC_TRADE_DETAIL_QUANTITY_WEIGHT_VOLUME_CONSISTENT_ACTUAL_OR_CONSIGNED,
  REQUIRE_MBL,
  REQUIRE_USER_DEFINED_ROLE_ID1,
  REQUIRE_USER_DEFINED_ROLE_ID2,
  BILL_TAX_ACCOUNT,
  BILL_COMPANY_EMAIL,
  REQUIRE_INVOICE_TITLE,
  REQUIRE_OPENING_BANK,
  REQUIRE_BANK_ACCOUNT_NUMBER,
  REQUIRE_OUR_TITLE,
  REQUIRE_AR_CHARGE_RATE,
  REQUIRE_AP_CHARGE_RATE,
  LOGIC_CHARGE_AR_AP_NINE_TAX_RATE,
  LOGIC_CHARGE_INVOICE_REVIEW_STATE,
  CHARGE_COST_TYPE_NOT_EMPTY,
  LOGIC_CHARGE_COST_TYPE_SAME,
  LOGIC_HBL_SELECTED_DESTINATION_PORT_REQUIRE,
  LOGIC_CONSIGNATION_COMPANY_SCOPE,
  LOGIC_RECEIVABLE_ACCOUNT_OBJECT_SCOPE,
  LOGIC_MBL_CONTAINER_TOTAL_MATCH,
  LOGIC_TRADE_DETAIL_ENGLISH_NAME,
  LOGIC_TRADE_DETAIL_PACK,
  LOGIC_TRADE_DETAIL_PACK_NAME,
  LOGIC_TRADE_DETAIL_HSCODE,
  LOGIC_TRADE_DETAIL_MARK,
  LOGIC_CHEMICAL_PRODUCT_CUS_CODE,
  COOPERATIVE_BUSINESS_STATE_CHECK,
  BILLING_CHARGE_CONFIRM_STATE_CHECK,
  LOGIC_OP_SALES_OFFICES_DIFFERENT,
  HBL_MERGES_KEEP_UP_WITH_WEIGHT,
  HBL_SPLITS_KEEP_UP_WITH_WEIGHT,
  REQUIRE_CHECKED_HBL,
  LOGIC_AR_ACCOUNT_CUSTOMER_CODE,
  LOGIC_CHEMICAL_PRODUCT_CUS_CODE,
  LOGIC_APPLICATION_STATUS_FOR_RELEASE,
  CLIENT_SCOPE_HAVE_CHARGE,
  LOGIC_MERGE_DISPLAY_FEES_NEED,
  LOGIC_INVOICE_NATURE,
  LOGIC_INVOICE_TAX_NATURE_SAME,
  LOGIC_UNIQUE_BUSINESS_REFERENCE_NUMBER,
  INVOICE_NOT_EMPTY,
  IS_ATTACHMENT_MISSING,
  CONTACT_PHONE,
  COUNTER_PARTY_BILLING_NO,
  INFORMATION_INVOICE_TITLE,
  INVOICE_IDENTIFICATION_NUMBER,
  INVOICE_HEADER_BANK_NOT_EMPTY,
  INVOICE_HEADER_NOT_DUPLICATED
])

// ----------------
// 验证类型
// ----------------

export const CATEGORY_PROFIT = new CommonState(1, '利润', 'Profit', PROFITS)
export const CATEGORY_REQUIRE = new CommonState(2, '必录项', 'Require', REQUIRES)
export const CATEGORY_DATA_LOGIC = new CommonState(3, '数据逻辑性', 'Data Logic', LOGICS)
export const CATEGORY_DATA_CHANGED = new CommonState(4, '数据变更', 'Data Changed', DATA_CHANGES)

export const CHECK_CATEGORIES = new Set([
  CATEGORY_PROFIT,
  CATEGORY_REQUIRE,
  CATEGORY_DATA_LOGIC,
  CATEGORY_DATA_CHANGED
])

export const CHECK_LOGIC_CATEGORIES = new Set([
  CATEGORY_DATA_LOGIC
])

export const CATEGORY_TYPE_MAPPING = { 1: 'profit', 2: 'require', 3: 'logic', 4: 'changed' }

export const NODE_REMARK_MAPPING = { 2: i18n.t('Message.NoModificationAllowedAfterBusinessSubmission') }

// ----------------
// 验证模式
// ----------------

export const MODE_WARNING = new CommonState(1, '警告', 'Warning')
export const MODE_ERROR = new CommonState(2, '错误', 'Error')
export const MODE_EMAIL = new CommonState(3, '邮件', 'Email')
export const MODE_TASK = new CommonState(4, '任务', 'Task')
export const MODE_AUDIT = new CommonState(5, '审核', 'Audit')

export const CHECK_MODES = new Set([
  MODE_WARNING,
  MODE_ERROR,
  MODE_EMAIL,
  MODE_TASK,
  MODE_AUDIT
])

export const CHECK_ERROR_MODES = new Set([MODE_ERROR])

// ----------------
// 关系
// ----------------

export const AND = new CommonState(0, '与', 'And')
export const OR = new CommonState(1, '或', 'Or')

export const RELATIONS = new Set([
  AND,
  OR
])

// ----------------
// 操作符
// ----------------

export const EQUAL = new CommonState('=', '等于', 'Equal')
export const GREATER_THAN_EQUAL = new CommonState('>=', '大于等于', 'Greater Than Equal')
export const LESS_THAN_EQUAL = new CommonState('<=', '小于等于', 'Less Than Equal')
export const NOT_EQUAL = new CommonState('!=', '不等于', 'Not Equal')
export const GREATER_THAN = new CommonState('>', '大于', 'Greater Than')
export const LESS_THAN = new CommonState('<', '小于', 'Less Than')
export const LIKE = new CommonState('LIKE', '包含', 'Like')
export const NOT_LIKE = new CommonState('NOT LIKE', '不包含', 'Not Like')
export const SATISFY_ONE = new CommonState('EXIST', '满足其一', 'Satisfy One Of Them')
export const NOT_EMPTY = new CommonState('NOT_EMPTY', '不为空', 'NOT EMPTY')

export const OPERATORS = new Set([
  EQUAL,
  GREATER_THAN_EQUAL,
  LESS_THAN_EQUAL,
  NOT_EQUAL,
  GREATER_THAN,
  LESS_THAN
])

export const ALL_OPERATOR = new Set([
  EQUAL,
  GREATER_THAN_EQUAL,
  LESS_THAN_EQUAL,
  NOT_EQUAL,
  GREATER_THAN,
  LESS_THAN,
  LIKE,
  NOT_LIKE,
  SATISFY_ONE,
  NOT_EMPTY
])

export const LIKE_OPERATOR = new Set([
  EQUAL,
  GREATER_THAN_EQUAL,
  LESS_THAN_EQUAL,
  NOT_EQUAL,
  GREATER_THAN,
  LESS_THAN,
  LIKE,
  NOT_LIKE
])

export const DELEGATION_CLIENT = new CommonState('0', '委托方', 'Delegation client')
export const RECEIVER_CLIENT = new CommonState('1', '接收方', 'Receiver client')
export const DELEGATION_OR_RECEIVER_CLIENT = new CommonState('2', '委托方或接收方', 'Delegation or receiver client')
export const CROSS_DELEGATION_ORDERS = new Set([
  DELEGATION_CLIENT,
  RECEIVER_CLIENT,
  DELEGATION_OR_RECEIVER_CLIENT
])

export const MASTER_ORDER = new CommonState('0', '主单', 'MAWB')
export const SLAVE_ORDER = new CommonState('1', '分单', 'HAWB')
export const DOCUMENT_TYPE = new Set([
  MASTER_ORDER,
  SLAVE_ORDER
])

// 发票收付方式
export const RECEIVABLE = new CommonState('1', '应收', 'Receivable')
export const PAYABLE = new CommonState('0', '应付', 'Payable')
export const PAYMENT_METHOD = new Set([
  RECEIVABLE,
  PAYABLE
])

export const TAX_NOT_EXEMPTION = new CommonState('0', '非免税', 'Non-tax-exempt')
export const TAX_EXEMPTION = new CommonState('1', '免税', 'Tax exemption')

export const TAX_NATURES = new Set([
  TAX_EXEMPTION,
  TAX_NOT_EXEMPTION
])

export const DOMESTIC = new CommonState('0', '国内', 'domestic')
export const OVERSEAS = new CommonState('1', '国外', 'overseas')

export const COUNTRY_TYPE = new Set([
  DOMESTIC,
  OVERSEAS
])

/**
 * 发票性质/税率标识
 */
export const INVOICE_NATURE_NORMAL = new CommonState(0, '正常', 'Normal')
export const INVOICE_NATURE_NON_TAXABLE = new CommonState(1, '不征税', 'Non Taxable')
export const INVOICE_NATURE_TAX_FREE = new CommonState(2, '免税', 'Tax Free')
export const INVOICE_NATURES = new Set([
  INVOICE_NATURE_NORMAL,
  INVOICE_NATURE_NON_TAXABLE,
  INVOICE_NATURE_TAX_FREE
])

// ----------------
// 过滤依据
// ----------------

export const DIMENSION_LOB = new CommonState('lob', '业务类型', 'Business Type', SystemConstants.LOBS)
export const DIMENSION_CONTAINER_LOG_TYPE = new CommonState('containerLoadType', '整拼类型', 'Container Load Type', SeaExportConstants.CONTAINER_LOAD_TYPES)
export const DIMENSION_IS_SHUTOUT = new CommonState('isShutOut', '是否退关', 'isShutOut', SystemConstants.YESORNO_STATES)
export const DIMENSION_IS_MASTERFLAG = new CommonState('isMasterFlag', '是否主票', 'isMasterFlag', SystemConstants.YESORNO_STATES)
export const DIMENSION_IS_LCL = new CommonState('isLcL', '是否小票', 'isLCL', SystemConstants.YESORNO_STATES)

export const DIMENSION_JOB_STATE = new CommonState('jobState', '业务状态', 'jobState', SystemConstants.JOB_STATES)
export const DIMENSION_CONTRACT_VALID = new CommonState('contractValid', '合约是否有效', 'contractValid', SystemConstants.YESORNO_STATES)
export const DIMENSION_WRITEOFFALL = new CommonState('writeOffAll', '是否完全核销', 'writeOffAll', SystemConstants.YESORNO_STATES)
export const DIMENSION_EXTENDED = new CommonState('isExtended', '账龄是否超期', 'isExtended', SystemConstants.YESORNO_STATES)
export const DIMENSION_EXCESSIVE = new CommonState('isExcessive', '信用额度是否超额', 'isExcessive', SystemConstants.YESORNO_STATES)
export const DIMENSION_MAKE_INVOICE = new CommonState('makeInvoice', '是否开票', 'makeInvoice', SystemConstants.YESORNO_STATES)
export const BOOKINGTERM = new CommonState('bookingTerm', '约价性质', 'bookingTerm', SystemConstants.BOOKINGTERMLIST)
export const RELEASESTATE = new CommonState('releaseState', '出单类型', 'releaseState', SystemConstants.CUSTOMER_SELF_RELEASE_STATES1)
export const DIMENSION_CARGOSOURCE = new CommonState('cargoSource', '揽货类型', 'cargoSource', SystemConstants.CARGO_SOURCES)
export const DIMENSION_CREDITTERM = new CommonState('creditTerm', '结算类型', 'creditTerm', SystemConstants.SETTLEMENTTYPE_TYPE)
export const DIMENSION_LOCAL_SERVICES = new CommonState('localServices', '本地服务', 'localServices', SystemConstants.LOCAL_SERVICES_TYPE)
export const DIMENSION_BOOKING_TERM_AE = new CommonState('bookingTermAE', '订舱性质', 'bookingTermAE', BookingTerm.BOOKING_TERMS)
export const DIMENSION_CUSTOM_JOB_TYPE = new CommonState('customJobType', '自定义业务类型', 'customJobType', [])
export const DIMENSION_SEA_AIR_REGION = new CommonState('seaAirRegion', '海空航线', 'seaAirRegion', [])
export const DIMENSION_RAILWAY_REGION = new CommonState('railwayRegion', '铁路航线', 'railwayRegion', [])
export const CHARGE_RELATED_MBL = new CommonState('chargeRelatedMbl', '费用关联提单号', 'chargeRelatedMbl', SystemConstants.YESORNO_STATES)
export const FEE_NAME = new CommonState('feeName', '费用名称', 'feeName', [])
export const MASTER_CONDITIONS_CARRIAGE = new CommonState('masterCarriage', '主单运输条款', 'masterConditionsCarriage', [])
export const SEPARATE_CONDITIONS_CARRIAGE = new CommonState('separateCarriage', '分单运输条款', 'separateConditionsCarriage', [])
export const DIMENSION_IS_EXIST_MBL = new CommonState('isExistMbl', '是否存在主单', 'is exist mbl', SystemConstants.YESORNO_STATES)
export const DIMENSION_IS_EXIST_HBL = new CommonState('isExistHbl', '是否存在分单', 'is exist hbl', SystemConstants.YESORNO_STATES)
export const DIMENSION_IS_EXIST_VIRTUAL_HBL = new CommonState('isExistVirtualHBL', '是否存在形式分单', 'is exist virtualHBL', SystemConstants.YESORNO_STATES)
export const DIMENSION_ADDED_SERVICES = new CommonState('addedServices', '增值服务', 'added services', SystemConstants.ADDED_SERVICES)
export const DIMENSION_POD_SERVICES = new CommonState('podServices', '目的港服务', 'port of destination services', SystemConstants.POD_SERVICES)
export const DIMENSION_CUSTOMER_SUPPLIER_TYPE = new CommonState('customerSupplierType', '客商类型', 'customer supplier type', PartnerServiceItem.PARTNER_SERVICE_ITEMS)
export const ALLOW_SALE_PRODUCT_IS_EXIST = new CommonState('allowSaleProduct', '可售卖产品是否为空', 'hasAllowSaleProduct', SystemConstants.YESORNO_STATES)
export const DIMENSION_EQ_TYPE = new CommonState('eqType', '箱种', 'Box type', [])
export const DIMENSION_PARENT_COMPANY = new CommonState('parentCompany', '委托单位是否母公司', 'Customer is the parent company', YES_NO_TYPES)
export const DIMENSION_GP_EXPLAIN = new CommonState('gpExplain', 'GP说明', 'GP Explain', SystemConstants.GP_EXPLAIN_STATUS)
export const DIMENSION_SALES = new CommonState('sales', '销售', 'Sales')
export const DIMENSION_SEA_COMPANY = new CommonState('seaCompany', '船公司', 'Sea Company')
export const DIMENSION_CROSS_DELEGATION_ORDER = new CommonState('crossDelegationOrder', '交叉委托订单', 'Cross Delegation Order', CROSS_DELEGATION_ORDERS)
export const INTEGRATED_ORDER_TYPE = new CommonState('integratedOrderType', '综合物流订单类型', 'Comprehensive logistics order type')
export const DIMENSION_RELEASE_BILL_OF_LADING_TYPE = new CommonState('releaseType', '放单提单类型', 'Release Bill of Lading Type', DOCUMENT_TYPE)
export const INVOICE_PAYMENT_METHOD = new CommonState('invoicePaymentMethod', '发票收付方式', 'Invoice Payment method', PAYMENT_METHOD)
export const DIMENSION_BILLING_PAYMENT_METHOD = new CommonState('billingPaymentMethod', '账单收付方式', 'Billing Payment method', PAYMENT_METHOD)
export const DIMENSION_TAX_NATURE = new CommonState('taxNature', '税务性质', 'Tax nature', TAX_NATURES)
export const DOMESTIC_AND_FOREIGN_BILLS = new CommonState('domesticForeignBill', '账单国内国外', 'Domestic and foreign bills', [])

export const DIMENSIONS = new Set([
  DIMENSION_LOB,
  DIMENSION_CONTAINER_LOG_TYPE,
  DIMENSION_IS_SHUTOUT,
  DIMENSION_IS_MASTERFLAG,
  DIMENSION_IS_LCL,
  DIMENSION_JOB_STATE,
  DIMENSION_CONTRACT_VALID,
  DIMENSION_WRITEOFFALL,
  DIMENSION_EXTENDED,
  DIMENSION_EXCESSIVE,
  DIMENSION_MAKE_INVOICE,
  BOOKINGTERM,
  RELEASESTATE,
  DIMENSION_CARGOSOURCE,
  DIMENSION_CREDITTERM,
  DIMENSION_LOCAL_SERVICES,
  DIMENSION_BOOKING_TERM_AE,
  DIMENSION_CUSTOM_JOB_TYPE,
  DIMENSION_SEA_AIR_REGION,
  DIMENSION_RAILWAY_REGION,
  CHARGE_RELATED_MBL,
  FEE_NAME,
  MASTER_CONDITIONS_CARRIAGE,
  SEPARATE_CONDITIONS_CARRIAGE,
  DIMENSION_IS_EXIST_MBL,
  DIMENSION_IS_EXIST_HBL,
  DIMENSION_IS_EXIST_VIRTUAL_HBL,
  DIMENSION_ADDED_SERVICES,
  DIMENSION_POD_SERVICES,
  DIMENSION_CUSTOMER_SUPPLIER_TYPE,
  DIMENSION_EQ_TYPE,
  DIMENSION_PARENT_COMPANY,
  ALLOW_SALE_PRODUCT_IS_EXIST,
  DIMENSION_GP_EXPLAIN,
  DIMENSION_SALES,
  DIMENSION_SEA_COMPANY,
  DIMENSION_CROSS_DELEGATION_ORDER,
  INTEGRATED_ORDER_TYPE,
  DIMENSION_RELEASE_BILL_OF_LADING_TYPE,
  INVOICE_PAYMENT_METHOD,
  DIMENSION_BILLING_PAYMENT_METHOD,
  DOMESTIC_AND_FOREIGN_BILLS,
  DIMENSION_TAX_NATURE
])

export const JOB = new CommonState('job', '业务', 'job')
export const USER = new CommonState('user', '用户', 'user')
